/* eslint-disable react/display-name */
import React from 'react';

export const indexBeforeAfter = [
  {
    before: {
      points: [
        {
          title: 'Novice Customer',
          description: 'Wants to invest in the capital market.',
        },
        {
          title: 'Dilemma',
          description:
            'Lack of knowledge, experience, and skills required to build wealth through trading.',
        },
        {
          title: 'Limited Market Knowledge',
          description:
            'An average person has to rely on information passed on from friends and family before choosing the right trading strategy.',
        },
        {
          title: 'Lack of Automation',
          description:
            'Capital market trading requires intense monitoring of the market in order to grab the right opportunities. Manual order placement involves delays and may be error-prone and stressful.',
        },
        {
          title: 'Broker',
          description:
            'You have to place a manual order using the web/mobile application provided by the broker or over a phone call.',
        },
        {
          title: 'Exchange',
          description:
            'All the orders are routed here but the high latency in manual order placement affects the actual traded price.',
        },
      ],
      image: {
        desktop: '/img/choose-before.svg',
        small: '/img/choose-before-small.jpg',
        mobile: '/img/choose-before-mob.svg',
      },
    },
    after: {
      points: [
        {
          title: 'Novice Customer',
          description: 'Wants to invest in the capital market',
        },
        {
          title: 'Stress-free Trading',
          description:
            'Approaches AlgoBulls because they are interested in investing in the capital market. Does not matter if one doesn’t have prior trading knowledge and experience. AlgoBulls is here to do all the work for him/her.',
        },
        {
          title: 'Ready-to-use Market Knowledge',
          description:
            'The days of depending on others for authentic trading information are over. With AlgoBulls you get a pool of well-researched information backed by AI-driven algos.',
        },
        {
          title: 'End-to-End Automation  ',
          description:
            'From complete monitoring of the market to grabbing the right investment opportunities for you, AlgoBulls leading-edge trading platform does all the work for you.',
        },
        {
          title: 'Broker',
          description:
            'Get complete freedom from inconvenient manual order placement as AlgoBulls places order on your behalf to your preferred broking house, without you having to sit through the process yourself.',
        },
        {
          title: 'Exchange',
          description:
            'As your order gets routed to the exchange with negligible latency, thanks to our powerful algos, you get to trade at the best price without compromising on anything.',
        },
      ],
      image: {
        desktop: '/img/choose-after.svg',
        small: '/img/choose-after-small.jpg',
        mobile: '/img/choose-after-mob.svg',
      },
    },
  },
  {
    before: {
      points: [
        {
          title: 'Market Professional ',
          description: 'Wants to invest in the capital market.',
        },
        {
          title: 'Dilemma',
          description:
            'Too much information to be analyzed every time before placing any order',
        },
        {
          title: 'Lack of Automation',
          description:
            'Capital market trading requires intense monitoring of the market in order to grab the right opportunities. Manual order placement involves delays and may be error-prone and stressful.',
        },
        {
          title: 'Broker',
          description:
            'You have to place a manual order using the web/mobile application provided by the broker or over a phone call.',
        },
        {
          title: 'Exchange',
          description:
            'All the orders are routed here but the high latency in manual order placement affects the actual traded price.',
        },
      ],
      image: {
        desktop: '/img/build-before.svg',
        small: '/img/build-before-small.jpg',
        mobile: '/img/build-before-mob.svg',
      },
    },
    after: {
      points: [
        {
          title: 'Market Professional ',
          description: 'Wants to invest in the capital market.',
        },
        {
          title: 'Stress-Free Trading',
          description:
            'Approaches AlgoBulls to get a tailor made strategy which is fully automated and requires no manual intervention during live trading. ',
        },
        {
          title: 'End-to-End Automation',
          description:
            'From complete monitoring of the market to grabbing the right investment opportunities for you, AlgoBulls leading-edge trading platform does all the work for you.',
        },

        {
          title: 'Broker',
          description:
            'Get complete freedom from inconvenient manual order placement as AlgoBulls places order on your behalf to your preferred broking house, without you having to sit through the process yourself.',
        },
        {
          title: 'Exchange',
          description:
            'As your order gets routed to the exchange with negligible latency, thanks to our powerful algos, you get to trade at the best price without compromising on anything.',
        },
      ],
      image: {
        desktop: '/img/build-after.svg',
        small: '/img/build-after-small.jpg',
        mobile: '/img/build-after-mob.svg',
      },
    },
  },
];

export const currencies = [
  {
    country: 'india',
    countryTitle: 'India',
    currencyCode: 'inr',
    symbol: '₹',
    icon: '/img/india.svg',
  },
  {
    country: 'united-states',
    countryTitle: 'USA',
    currencyCode: 'usd',
    symbol: '$',
    icon: '/img/united-states.svg',
  },
];

const productArrowRight = (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 16.3 16"
    style={{ enableBackground: 'new 0 0 16.3 16' }}>
    <path
      d="M1,8h14.1"
      style={{
        fill: 'none',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLineJoin: 'round',
      }}
    />
    <path
      d="M8.1,1l7.1,7l-7.1,7"
      style={{
        fill: 'none',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLineJoin: 'round',
      }}
    />
  </svg>
);

// const videoPlay = (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 18 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg">
//     <path d="M9 16.2C5.04 16.2 1.8 12.96 1.8 9C1.8 5.04 5.04 1.8 9 1.8C12.96 1.8 16.2 5.04 16.2 9C16.2 12.96 12.96 16.2 9 16.2ZM9 0C4.05 0 0 4.05 0 9C0 13.95 4.05 18 9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 0 9 0ZM7.2 13.05L12.6 9L7.2 4.95V13.05Z" />
//   </svg>
// );

function GreenCheckImage() {
  return <img src="/img/green-check.svg" alt="check" />;
}

export const products = {
  build: {
    pageTitle: 'Build Strategies',
    pageDescription: 'Build Personalized Strategies',
    hero: {
      h1: (
        <>
          <span style={{ color: '#2C78F6' }}>Build</span> your own path to
          successful trading
        </>
      ),
      subhead:
        'Design & Build your own signature trading algos on our robust trading platform with ease',
      cta: {
        link: '#pricing',
        label: 'Explore Options',
      },
    },
    options: [
      {
        id: 'pro-build',
        title: 'Pro Build',
        description:
          'Do you have a great trading strategy up your sleeve but lack necessary coding skills? Worry no further, with our Pro Build approach, you can now get your winning trading strategies coded by our in-house experts and delivered to you in a matter of days.',
        price: {
          inr: '25,000',
          usd: '126',
        },
        cta: [
          {
            id: 0,
            link: '#contact',
            label: (
              <>
                Request a Quote
                {productArrowRight}
              </>
            ),
          },
          /* {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            withPopup: true,
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          }, */
        ],
        image: '/img/pro-build.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: 'Sign Up/Login to your account',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Share',
            description: (
              <>
                Share your strategy with us. You can take a look at the{' '}
                <a
                  href="https://github.com/algobulls/pro_build_strategy_documentation_templates"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2c78f6' }}>
                  sample strategy templates
                </a>{' '}
                to get started.
              </>
            ),
            icon: '/img/share-icon.svg',
          },
          {
            id: 2,
            title: 'Get Quote',
            description:
              'Receive a quote for your strategy and make the payment.',
            icon: '/img/get-quote-icon.svg',
          },
          {
            id: 3,
            title: 'Get Strategy',
            description:
              'Get the strategy delivered to your AlgoBulls account.',
            icon: '/img/receive-code-icon.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With the powerful combination of your strategy and our coding, dive into the exciting world of trading!',
            icon: '/img/start-trade-icon.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      {
        id: 'python-build',
        title: 'AlgoBulls Build',
        description:
          'Built specifically for the coder in you, AlgoBulls offers you a rare chance to code your own strategy or modify some of our ready-made templates, leveraging our state-of-the-art tech to support and propel your exclusive trading strategies, giving the inner techie in you a shot at creating powerful trading codes. You can code directly on our website without having to install Python or any other software locally on your laptop. Get your strategy approved for live trading from our experts and deploy it on 30+ supported brokers without coding any broker integration logic.',
        price: {
          inr: '2,000',
          usd: '25',
        },
        cta: [
          {
            id: 0,
            link: 'https://app.algobulls.com/build/python',
            label: (
              <>
                Begin Coding Now
                {/* {productArrowRight} */}
              </>
            ),
          },
          /* {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          }, */
        ],
        image: '/img/python-build.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: 'Sign-Up/Login from your account',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select a Developer Plan',
            description:
              'Pick the right package as per your coding proficiency.',
            icon: '/img/check-icon.svg',
          },
          {
            id: 2,
            title: 'Design',
            description: (
              <>
                Code your strategy or modify existing strategies directly on our
                website. Check out some sample strategies{' '}
                <a
                  href="https://github.com/algobulls/pyalgostrategypool/tree/master/pyalgostrategypool"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2c78f6' }}>
                  here.
                </a>
              </>
            ),
            icon: '/img/design-icon.svg',
          },
          {
            id: 3,
            title: 'Test',
            description:
              'Mobilize & test your strategy via Backtesting and Paper Trading on our platform.',
            icon: '/img/test-icon.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With every parameter set, you can start your real trading journey at the click of a button!',
            icon: '/img/start-trade-icon.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      {
        id: 'python-desktop-build',
        title: 'Python Desktop Build',
        description:
          'Once you opt for this product, you get a unique API key that lets you connect your system with our server where you can utilize the power of our platform to uniquely code in Python and setup your trading strategies for your desired results. All you need is Python installed & other necessary software on your laptop.',
        price: {
          inr: '3,500',
          usd: '44',
        },
        cta: [
          {
            id: 0,
            link: 'https://algobulls.github.io/pyalgotrading/introduction/',
            label: (
              <>
                Hands-on Tutorial
                {productArrowRight}
              </>
            ),
          },
          /* {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          }, */
        ],
        image: '/img/python-desktop-build.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description:
              'Sign Up/Login to your account. Install Python and your favourite Python IDE.',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select',
            description: 'Select the right package as per your coding skills.',
            icon: '/img/check-icon.svg',
          },
          {
            id: 2,
            title: 'Design',
            description: (
              <>
                Code your strategy in your favourite Python IDE. Check out some
                sample strategy code{' '}
                <a
                  href="https://github.com/algobulls/pyalgostrategypool/tree/master/pyalgostrategypool"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2c78f6' }}>
                  here.
                </a>
              </>
            ),
            icon: '/img/design-icon.svg',
          },
          {
            id: 3,
            title: 'Test',
            description:
              'Mobilize & test your strategy via Backtesting and Paper Trading on our platform.',
            icon: '/img/test-icon.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With every parameter set, you can start your real trading journey at the click of a button!',
            icon: '/img/start-trade-icon.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      /* {
        id: 'classic-build',
        title: 'Classic Build',
        description:
          'Simple yet highly sophisticated approach to building your own unique trading algos through easy Drag-and-Drop features that kickstart your trading journey within minutes.',
        price: {
          inr: '2,500',
          usd: '35',
        },
        cta: [
          {
            id: 0,
            link: '#!',
            label: (
              <>
                Coming Soon
              </>
            ),
          },
          {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          },
        ],
        image: '/img/classic-build.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: 'Sign Up/Login to your account',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select',
            description:
              'Select the right package as per your coding appetite.',
            icon: '/img/check-icon.svg',
          },
          {
            id: 2,
            title: 'Design',
            description:
              'Create your own strategy through easy Drag-and-drop model.',
            icon: '/img/design-icon.svg',
          },
          {
            id: 3,
            title: 'Deploy',
            description: 'Load and activate your strategy on our platform.',
            icon: '/img/test-icon.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With everything in place, you can now Backtest, Paper Trade or Real Trade on your strategies.',
            icon: '/img/start-trade-icon.svg',
          },
        ],
        learnMoreLink: '#!',
      }, */
      /* {
        id: 'software-for-research',
        title: 'Software for Research',
        description:
          'Replete with robust data visualization along with software and plug-ins that you can easily download in your system, this exclusive product line is an end to all your research woes, rendering accurate and authentic data sets critical to your said needs.',
        price: {
          inr: '15,000',
          usd: '200',
        },
        cta: [
          {
            id: 0,
            link: '#!',
            label: (
              <>
                Instituition Marketplace
                {productArrowRight}
              </>
            ),
          },
          {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          },
        ],
        image: '/img/choose-social-trading.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: 'Sign Up/Login to your account',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Connect',
            description: 'Sync your strategy through unique API key.',
            icon: '/img/connect-icon.svg',
          },
          {
            id: 2,
            title: 'Select',
            description: 'Select the investment package that suits you.',
            icon: '/img/check-icon.svg',
          },
          {
            id: 3,
            title: 'Test',
            description: 'Test your strategy on our platform.',
            icon: '/img/test-icon.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With just a click of a button start your trading process!',
            icon: '/img/start-trade-icon.svg',
          },
        ],
        learnMoreLink: '#!',
      }, */
    ],
    features: [
      {
        id: 0,
        icon: '/img/broker-icon.svg',
        title: 'Real Trading across full-spectrum of brokers',
        description:
          'Make your expert trading strategies open for real trading across all our supported brokers, without having to write a single line of broker integration code. Moreover, your strategy is directly available for all new compatible brokers, integrated after your strategy is deployed.',
      },
      {
        id: 1,
        icon: '/img/transparent-and-authentic.svg',
        title: 'Seamless Paper Trading',
        description:
          'Unlock the power of secure and authentic trading opportunities on our platform where you can test out your trading algo via real-time Paper Trading before diving into Live Trading with your money.',
      },
      {
        id: 2,
        icon: '/img/backtesting-icon.svg',
        title: 'Effortless Backtesting',
        description:
          'Who says you have to bear the brunt of fickle markets with your actual money? Get access to historical backtesting data with AlgoBulls, before entering the real market with real money.',
      },
      {
        id: 3,
        icon: '/img/pro-customizations.svg',
        title: 'Pro-customizations',
        description:
          'Tinker with more than 25 trading parameters to create millions of combinations, building effective & cogent trading algorithms that are 100% you.',
      },
      {
        id: 4,
        icon: '/img/select-package.svg',
        title: 'List & Earn',
        description:
          'List your powerful, time-tested trading strategies for the public and earn revenue by empowering other customers on our platform with your trading expertise.',
      },
      {
        id: 5,
        icon: '/img/consultancy-icon.svg',
        title: 'Consultancy',
        description:
          'AlgoBulls not only gives you a smart platform to build your strategies, but it also provides you expert algorithmic advisory on how to design and deploy the right strategy that works efficiently within our algo architecture.',
      },
    ],
    pricing: {
      features: [
        {
          id: 0,
          content: (
            <p>
              Convenience Charges
              <span className="price-pop">
                Charges for using this product to build customized strategies
              </span>
            </p>
          ),
        },
        {
          id: 1,
          content: (
            <p>
              Deployment Charges
              <span className="price-pop">
                Monthly recurring charges for strategy deployment
              </span>
            </p>
          ),
        },
        {
          id: 2,
          content: (
            <p>
              Templates
              <span className="price-pop">
                Ready examples to kick-start your building
              </span>
            </p>
          ),
        },
        {
          id: 3,
          content: (
            <p>
              Support (Online)
              <span className="price-pop">
                Support from AlgoBulls team over Community Forum
              </span>
            </p>
          ),
        },
        {
          id: 4,
          content: (
            <p>
              Consultation (Phone Call)
              <span className="price-pop">
                Expert consultation from AlgoBulls team over phone call
              </span>
            </p>
          ),
        },
        {
          id: 5,
          content: (
            <p>
              Software Installation
              <span className="price-pop">
                Additional software required to be installed at your end
              </span>
            </p>
          ),
        },
        {
          id: 6,
          content: (
            <p>
              Coding Skills
              <span className="price-pop">
                Are Programming skills required to use this product?
              </span>
            </p>
          ),
        },
        {
          id: 7,
          content: null,
        },
      ],
      products: [
        {
          id: 'pricing-pro-build',
          heading: 'Pro Build',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '10,000', usd: '126' }[currency]}
                  <span>Onwards / Strategy</span>
                </p>
              ),
            },
            {
              id: 2,
              content: (currency, getCurrencySymbol) => (
                <h4>
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,000', usd: '25' }[currency]}
                  <span>Per Month</span>
                </h4>
              ),
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => <GreenCheckImage />,
            },
            {
              id: 6,
              content: () => null,
            },
            {
              id: 7,
              content: () => null,
            },
            {
              id: 8,
              content: () => (
                <a href="#contact" className="button button-border">
                  Request a Quote
                </a>
              ),
            },
          ],
        },
        {
          id: 'pricing-python-build',
          heading: 'AlgoBulls Build',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,000', usd: '25' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            {
              id: 2,
              content: (currency, getCurrencySymbol) => (
                <h4>
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,000', usd: '25' }[currency]}
                  <span>Per Month</span>
                </h4>
              ),
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => null,
            },
            {
              id: 6,
              content: () => null,
            },
            {
              id: 7,
              content: () => <GreenCheckImage />,
            },
            {
              id: 8,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?category=Developers"
                  className="button button-border">
                  Explore Plans
                </a>
              ),
            },
          ],
        },
        {
          id: 'pricing-python-desktop-build',
          heading: 'Python Desktop Build',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '3,500', usd: '44' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            {
              id: 2,
              content: (currency, getCurrencySymbol) => (
                <h4>
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,000', usd: '25' }[currency]}
                  <span>Per Month</span>
                </h4>
              ),
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => null,
            },
            {
              id: 6,
              content: () => <GreenCheckImage />,
            },
            {
              id: 7,
              content: () => <GreenCheckImage />,
            },
            {
              id: 8,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?category=Developers"
                  className="button button-border"
                  target="_blank"
                  rel="noopener noreferrer">
                  Explore Plans
                </a>
              ),
            },
          ],
        },
        /* {
          id: 'pricing-classic-build',
          heading: 'Classic Build',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,500', usd: '35' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            {
              id: 2,
              content: (currency, getCurrencySymbol) => (
                <h4>
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,000', usd: '30' }[currency]}
                  <span>Per Month</span>
                </h4>
              ),
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => <></>,
            },
            {
              id: 6,
              content: () => <></>,
            },
            {
              id: 7,
              content: () => <></>,
            },
            {
              id: 8,
              content: () => (
                <a href="#!" className="button button-border">
                  Coming Soon
                </a>
              ),
            },
          ],
        },
        {
          id: 'pricing-software-for-research',
          heading: 'Software for Research',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '15,000', usd: '200' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            {
              id: 2,
              content: (currency, getCurrencySymbol) => (
                <h4>
                  {getCurrencySymbol(currency)}
                  {{ inr: '2,000', usd: '30' }[currency]}
                  <span>Per Month</span>
                </h4>
              ),
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => <GreenCheckImage />,
            },
            {
              id: 6,
              content: () => <GreenCheckImage />,
            },
            {
              id: 7,
              content: () => <GreenCheckImage />,
            },
            {
              id: 8,
              content: () => (
                <a href="#!" className="button button-border">
                  Explore Packages
                </a>
              ),
            },
          ],
        }, */
      ],
    },
  },
  choose: {
    pageTitle: 'Choose Your Strategy | AI-backed trading strategies',
    pageDescription:
      'Built-in trading solutions backed by powerful AI-driven algorithms. Choose from three types of marketplaces for Retail, Premium, HNI. Choose your marketplace and get onboard.',
    hero: {
      h1: (
        <>
          <span style={{ color: '#2C78F6' }}>Choose</span> from our wide range
          of AI-backed trading strategies
        </>
      ),
      subhead:
        'Built-in trading solutions backed by powerful AI-driven algorithms, for anyone and everyone',
      cta: {
        link: 'https://app.algobulls.com/marketplace/',
        label: 'Explore Marketplace',
      },
    },
    options: [
      {
        id: 'retail',
        title: 'Retail',
        description:
          'If you are an individual, aiming to make it big in capital market trading, you have reached the right place. With our carefully curated trading algos, suitable for all, be it an amateur or an expert, you get the chance to hit the home run in the market.',
        price: {
          inr: '1,000',
          usd: '13',
        },
        cta: [
          {
            id: 0,
            link: 'https://app.algobulls.com/marketplace/category/retail',
            label: (
              <>
                Retail Marketplace
                {productArrowRight}
              </>
            ),
          },
          /* {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          }, */
        ],
        image: '/img/choose-retail-new.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: (
              <>
                Sign Up/Login to your account. Checkout the{' '}
                <i>Retail Marketplace</i>.
              </>
            ),
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select Strategy',
            description:
              'Choose from a wide range of strategies. Make sure the investment size & risk appetite fits your criteria.',
            icon: '/img/strategy.svg',
          },
          {
            id: 2,
            title: 'Select a Plan',
            description:
              'Pick the right AlgoBulls subscription plan for yourself.',
            icon: '/img/select-package.svg',
          },
          {
            id: 3,
            title: 'Add a Broker',
            description: 'Add a suitable broker to your AlgoBulls account.',
            icon: '/img/risk-setting.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With all the parameters set, you can now start trading!',
            icon: '/img/start-trading.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      {
        id: 'premium',
        title: 'Premium',
        description:
          'Enabling you to trade through Index Options with our sophisticated, powerful, and rugged trading algos, bringing a careful scientific approach to the highly pulsating trading world.',
        price: {
          inr: '4,500',
          usd: '57',
        },
        cta: [
          {
            id: 0,
            link: 'https://app.algobulls.com/marketplace/category/premium',
            label: (
              <>
                Premium Marketplace
                {productArrowRight}
              </>
            ),
          },
          /* {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          }, */
        ],
        image: '/img/choose-premium-new.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: (
              <>
                Initiate by signing up or logging in to your account. Checkout
                the <i>Premium Marketplace</i>.
              </>
            ),
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select Strategy',
            description: (
              <>
                Pick from a diverse range of strategies. Ensure that the
                investment size &amp; risk factor matches your requirement.
              </>
            ),
            icon: '/img/strategy.svg',
          },
          {
            id: 2,
            title: 'Select a Plan',
            description:
              'Pick the right AlgoBulls subscription plan for yourself.',
            icon: '/img/select-package.svg',
          },
          {
            id: 3,
            title: 'Add a Broker',
            description: 'Add a suitable broker to your AlgoBulls account.',
            icon: '/img/risk-setting.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description: 'Ready, set, start trading with a click of a button!',
            icon: '/img/start-trading.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      {
        id: 'hni',
        title: 'High Net Worth Individual',
        description:
          'Begin trading in the capital markets with our robust AI-driven trading algos designed for the specific demands & risk appetite of the HNI clientele.',
        price: {
          inr: '7,500',
          usd: '94',
        },
        cta: [
          {
            id: 0,
            link: 'https://app.algobulls.com/marketplace/category/hni',
            label: (
              <>
                HNI Marketplace
                {productArrowRight}
              </>
            ),
          },
          /* {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          }, */
        ],
        image: '/img/choose-hni-new.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description: (
              <>
                Begin by signing up or logging in to your account and checking
                out the <i>HNI Marketplace</i>
              </>
            ),
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select Strategy',
            description:
              'SeSelect from a wide array of trading strategies keeping in mind the investment size & risk factor.',
            icon: '/img/strategy.svg',
          },
          {
            id: 2,
            title: 'Select a Plan',
            description:
              'Pick the right AlgoBulls subscription plan for yourself.',
            icon: '/img/select-package.svg',
          },
          {
            id: 3,
            title: 'Add a Broker',
            description: 'Add a suitable broker to your AlgoBulls account.',
            icon: '/img/risk-setting.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description: 'With everything in place, you can now start trading!',
            icon: '/img/start-trading.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      /* {
        id: 'ultra-hni',
        title: 'Ultra High Net Worth Individual',
        description:
          'Unlock unlimited potential of wealth creation through smart capital market trading algos, where we help you seize the best investment options and even spot potential "black swan" ventures that can boost your profitability manifold.',
        price: {
          inr: '15000',
          usd: '200',
        },
        cta: [
          {
            id: 0,
            link: 'https://app.algobulls.com/marketplace/category/ultrahni',
            label: (
              <>
                Ultra HNI Marketplace
                {productArrowRight}
              </>
            ),
          },
          {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          },
        ],
        image: '/img/choose-ultra-high-net-worth.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description:
              'Begin by signing up or logging in to your account and checking the investment & risk size for this module.',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select Strategy',
            description:
              'Pick out the best trading strategy that fits your portfolio.',
            icon: '/img/strategy.svg',
          },
          {
            id: 2,
            title: 'Select Package',
            description: 'Pick out the right AlgoBulls subscription package.',
            icon: '/img/select-package.svg',
          },
          {
            id: 3,
            title: 'Risk & Broker Setting',
            description:
              'Add in your risk factor & bind with a suitable broker.',
            icon: '/img/risk-setting.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'And with just a click of a button, you can now start trading.',
            icon: '/img/start-trading.svg',
          },
        ],
        learnMoreLink: '#!',
      },
      {
        id: 'institution',
        title: 'Institution',
        description:
          'Prudent, proficient, and powerful AI-driven trading solutions, apposite to large-scale institutional trading, dedicated towards accurate fundamental & technical analysis that mitigate losses & multiply returns.',
        price: {
          inr: '25000',
          usd: '350',
        },
        cta: [
          {
            id: 0,
            link:
              'https://app.algobulls.com/marketplace/category/institutional',
            label: (
              <>
                Institution Marketplace
                {productArrowRight}
              </>
            ),
          },
          {
            id: 1,
            link: 'https://www.youtube.com/watch?v=jlAmzId6Z6k',
            label: (
              <>
                {videoPlay}
                Watch Video
              </>
            ),
          },
        ],
        image: '/img/choose-institution.png',
        steps: [
          {
            id: 0,
            title: 'Get Started',
            description:
              'Sign up or log in to your institutional account and check the investment & risk criteria for the same.',
            icon: '/img/shield-check.svg',
          },
          {
            id: 1,
            title: 'Select Strategy',
            description:
              'You can choose from a large pool of result-oriented strategies.',
            icon: '/img/strategy.svg',
          },
          {
            id: 2,
            title: 'Select Package',
            description:
              'Select the AlgoBulls package that fits your requirement the best.',
            icon: '/img/select-package.svg',
          },
          {
            id: 3,
            title: 'Risk & Broker Setting',
            description:
              'Add in your risk factor & bind with a suitable broker.',
            icon: '/img/risk-setting.svg',
          },
          {
            id: 4,
            title: 'Start Trading',
            description:
              'With everything in place, you can now start your trading process with AlgoBulls.',
            icon: '/img/start-trading.svg',
          },
        ],
        learnMoreLink: '#!',
      }, */
    ],
    features: [
      {
        id: 0,
        icon: '/img/strategy-tweak-icon.svg',
        title: 'Diverse Strategy Pool',
        description: `Select from a rich collection of algo trading strategies, designed to accommodate different trading styles. Whether you're a beginner trader or an expert, Odyssey empowers you with a secure and authentic trading experience, ensuring there's a strategy that surts your specific approach.`,
      },
      {
        id: 1,
        icon: '/img/transparent-and-authentic.svg',
        title: 'Transparent & Authentic Virtual Trading',
        description: `With Odyssey, experience transparent and authentic virtual trading through accurate simulations of real trading scenarios. This allows you to analyse potential trades thoroughly before entering the real market, helping you to practise and refine your skills in a risk-free environment`,
      },
      // {
      //   id: 2,
      //   icon: '/img/return-calculator.svg',
      //   title: 'Returns calculator',
      //   description:
      //     'Wondering how to calculate your net returns at the end of each day, after removing all brokerage and other payments? Simple, try our returns calculator feature that lets you not only calculate final in-hand profits but also the net risk associated with each trading activity.',
      // },
      {
        id: 3,
        icon: '/img/strategy-pool.svg',
        title: 'Comprehensive End-to-End Reporting',
        description: `Receive complete end-to-end reporting that gives you a clear overview of your trading activities. Odyssey provides complete analysis of your current positions and investments, ensuring that you're always informed and able to make data-driven decisions.`,
      },
      {
        id: 4,
        icon: '/img/end-to-end-encryption.svg',
        title: 'Extensive Customisation Options.',
        description: `With Odyssey, you're not limited to pre-defined strategies. Our platform allows you to tweak and refine your trading strategies using more than 25 different parameters, enabling you to either customise our strategies or get your own custom strategy developed by our team that suits your unique trading needs and preferences.`,
      },
      {
        id: 5,
        icon: '/img/customizations-galore.svg',
        title: 'Powerful Data Insights',
        description: `Get robust data visualisations to monitor your trading strategies over time. Odyssey offers powerful insights into performance, allowing you to track key metrics such as Profit & Loss, Trading Volume, Total Trades and more. These insights provide a deeper understanding of your trading journey and help in strategic decision-making.`,
      },
      {
        id: 6,
        icon: '/img/hero-icon-4.svg',
        title: 'Multi-Mode Execution',
        description: `Experience strategies in multiple ways-backtest using historical data, engage in paper trading for realistic practice without financial risk, or seamlessly switch to live trading. Odyssey's flexibility allows you to choose the mode that best suits your current confort level and goals.`,
      },
      {
        id: 7,
        icon: '/img/inclusive-icon.svg',
        title: 'Strategies for All Experience Levels',
        description: `Odyssey caters to traders of all experience levels. From beginner-friendly approaches to advanced, high-complexity strategies, we ensure that every trader finds a suitable solution to enhance their trading journey`,
      },
      {
        id: 8,
        icon: '/img/powerful-insights.svg',
        title: 'Diverse Market Coverage',
        description: `Worried how your trading strategies are performing over time? With Odyssey, you get to observe returns, profits, risk, and more over time through robust data visualisations.`,
      },
      {
        id: 9,
        icon: '/img/testing-icon.svg',
        title: 'Built-In Risk Management',
        description: `Each strategy on Odyssey is equipped with risk management features, such as stop-loss settings. and other protective mechanisms. This approach ensures that risk considerations are an inhererit part of the trading process, providing additional layers of security`,
      },
      {
        id: 10,
        icon: '/img/tweak-icon.svg',
        title: 'Expert-Crafted Algorithms',
        description: `Every strategy within Odyssey has been meticulously crafted by experienced quantitative analysts and traders. Leveraging years of expertise, our strategies provide you with a solid foundation for algorithmic trading, crafted to operate in diverse market conditions.`,
      },
    ],
    pricing: {
      features: [
        {
          id: 0,
          content: <p>Pricing</p>,
        },
        // {
        //   id: 1,
        //   content: (
        //     <p>
        //       ROI Calculator
        //       <span className="price-pop">
        //         Dedicated Calculator for calculating Returns on Investment
        //       </span>
        //     </p>
        //   ),
        // },
        {
          id: 2,
          content: (
            <p>
              Free Backtesting Report
              <span className="price-pop">
                Marketplace displays free Backtesting report for all strategies
                in this segment
              </span>
            </p>
          ),
        },
        {
          id: 3,
          content: (
            <p>
              Strategy Parameters
              <span className="price-pop">
                Strategy working is disclosed to the customer
              </span>
            </p>
          ),
        },
        {
          id: 4,
          content: (
            <p>
              Customization
              <span className="price-pop">
                Strategy can be customized by customer
              </span>
            </p>
          ),
        },
        // {
        //   id: 5,
        //   content: (
        //     <p>
        //       Free Live Paper Trading
        //       <span className="price-pop">
        //         Marketplace displays free live Paper Trading within market hours
        //       </span>
        //     </p>
        //   ),
        // },
      ],
      products: [
        {
          id: 'pricing-retail',
          heading: 'Retail',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '1,000', usd: '13' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            // {
            //   id: 1,
            //   content: () => <GreenCheckImage />,
            // },
            {
              id: 2,
              content: () => <GreenCheckImage />,
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            // {
            //   id: 5,
            //   content: () => <GreenCheckImage />,
            // },
            {
              id: 6,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?category=Smart%20Plans"
                  className="button button-border"
                  target="_blank"
                  rel="noopener noreferrer">
                  Explore Plans
                </a>
              ),
            },
          ],
        },
        {
          id: 'pricing-premium',
          heading: 'Premium',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '4,500', usd: '57' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            // {
            //   id: 1,
            //   content: () => <GreenCheckImage />,
            // },
            {
              id: 2,
              content: () => <GreenCheckImage />,
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            // {
            //   id: 5,
            //   content: () => <></>,
            // },
            {
              id: 6,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?category=Smart%20Plans"
                  className="button button-border"
                  target="_blank"
                  rel="noopener noreferrer">
                  Explore Plans
                </a>
              ),
            },
          ],
        },
        {
          id: 'pricing-hni',
          heading: 'High Net Worth Individual',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '7,500', usd: '94' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            // {
            //   id: 1,
            //   content: () => <GreenCheckImage />,
            // },
            {
              id: 2,
              content: () => <GreenCheckImage />,
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            // {
            //   id: 5,
            //   content: () => <></>,
            // },
            {
              id: 6,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?category=Smart%20Plans"
                  className="button button-border"
                  target="_blank"
                  rel="noopener noreferrer">
                  Explore Plans
                </a>
              ),
            },
          ],
        },
        /* {
          id: 'pricing-hni',
          heading: 'Ultra High Net Worth Individual',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '15000', usd: '200' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            {
              id: 1,
              content: () => <GreenCheckImage />,
            },
            {
              id: 2,
              content: () => <GreenCheckImage />,
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => <></>,
            },
            {
              id: 6,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?defaultCategory=ultraHniStrategies"
                  className="button button-border"
                  target="_blank"
                  rel="noopener noreferrer">
                  Explore Plans
                </a>
              ),
            },
          ],
        },
        {
          id: 'pricing-institution',
          heading: 'Institution',
          cells: [
            {
              id: 0,
              content: (currency, getCurrencySymbol) => (
                <p className="product-price">
                  {getCurrencySymbol(currency)}
                  {{ inr: '25000', usd: '350' }[currency]}
                  <span>Onwards / Month</span>
                </p>
              ),
            },
            {
              id: 1,
              content: () => <GreenCheckImage />,
            },
            {
              id: 2,
              content: () => <GreenCheckImage />,
            },
            {
              id: 3,
              content: () => <GreenCheckImage />,
            },
            {
              id: 4,
              content: () => <GreenCheckImage />,
            },
            {
              id: 5,
              content: () => <></>,
            },
            {
              id: 6,
              content: () => (
                <a
                  href="https://app.algobulls.com/wallet?defaultCategory=institutionalStrategies"
                  className="button button-border"
                  target="_blank"
                  rel="noopener noreferrer">
                  Explore Plans
                </a>
              ),
            },
          ],
        }, */
      ],
    },
  },
};

export const testimonials1 = [
  {
    id: 0,
    title: 'It was a great experience',
    comment:
      "I would like to thanks AlgoBulls for creating this amazing platform where anyone, literally anyone, can open an account and start trading. You don't need any prior experience or knowledge. And be assured that you will get the most authentic and latest information.",
    user: {
      name: 'Sachin Saran',
      position: '',
      image: '/img/user.png',
      links: {
        //        facebook: '#!',
        //        twitter: '#!',
      },
    },
  },
  {
    id: 1,
    title: 'Delightfully Surprised',
    comment:
      'I always assumed making money through trading is something that only trading experts get to do. But AlgoBulls is an innovative platform that is based purely on scientific calculations and in-depth market knowledge. It has helped me, a complete trading novice make big bucks. I am delightfully surprised how easy it is to crack capital market trading with AlgoBulls. ',
    user: {
      name: 'Suresh Nair',
      position: '',
      image: '/img/user.png',
      links: {
        //        facebook: '#!',
        //        twitter: '#!',
      },
    },
  },
  {
    id: 1,
    title: 'Powerful',
    comment:
      "With AlgoBulls, I finally found a platform which provided me the necessary tech to bring my unique trading strategies to life. I don't really know coding so its extremely helpful for professional traders like me who know everything about the market but lack necessary skills and knowledge to make it usable in a tech-driven world.",
    user: {
      name: 'Sathish Sahu',
      position: 'Business Development Manager',
      image: '/img/user.png',
      links: {
        //        facebook: '#!',
        //        twitter: '#!',
      },
    },
  },
];

export const phoenix = {
  'step-1': {
    heading: 'Creation of Strategies',
    slides: [
      {
        image: '/img/python-step-1-code.png',
        title: 'Code from Scratch',
        alt: 'Code from Scratch',
        description:
          "If you're a trading pro itching to build your strategy from the ground up, this feature is your playground. Maximum flexibility, complete control—it's all at your fingertips.",
      },
      {
        image: '/img/phoenixStep1Slider1.png',
        title: 'Template Library',
        alt: 'template library',
        description:
          'In a hurry or seeking tested strategies?  Dive into our collection of pre-made templates, developed and vetted by our experts. Use them as they are or tweak them to match your unique market requirements.',
      },
    ],
  },
  'step-2': {
    image: '/img/tweak.png',
    alt: 'step 2 image',
    title: 'Set Your paramaters',
    description: `Once you've selected or created a strategy, it's time to fine-tune the parameters. Head over to the "Configuration Parameters" tab, where you can customise key settings like underlying securities, candle size, maximum order count, and specific user-defined parameters.`,
  },
  'step-3': {
    image: '/img/execution.png',
    alt: 'step 3 image',
    title: 'Execution of Strategy',
    description:
      'With everything set, execute your strategy with our unified code for Back-testing, Paper-Trading, and Live-Trading. AlgoBulls also has an inbuilt RMS for Loss Control and access to Live and Historical data  from authorised data vendors  for better decision making.',
  },
  'step-4': {
    image: '/img/Phoenix Analytics.png',
    alt: 'step 4 image',
    title: 'View your analytics',
    description: `As you execute your strategies, an in-depth visual analytics can be seen to view and tweak the performance of strategy until it's satisfactory.
    If you are not satisfied with the results, you can configure parameters while execution without touching the codebase.`,
  },
};

export const probuildSteps = {
  'step-1': {
    image: '/img/probuildStep1.png',
    alt: 'step 1 image',
    title: 'Initial Consultation',
    description: `
    Begin your journey by sharing the details of your desired strategy with our expert team. Clearly outline your trading goals, preferred market conditions, indicators, and risk preferences. This step ensures we fully understand your unique requirements and vision, setting the foundation for a strategy tailored exclusively to your needs..
    `,
  },
  'step-2': {
    image: '/img/probuildStep2.png',
    alt: 'step 2 image',
    title: 'Strategy Development',
    description:
      'Using state-of-the-art technology and extensive industry expertise, our professionals transform your outlined strategy into a robust trading algorithm. This process involves meticulously translating your ideas and requirements into code, ensuring every detail aligns with your trading objectives.',
  },
  'step-3': {
    image: '/img/probuildStep3.png',
    alt: 'step 3 image',
    title: 'Comprehensive Testing & Optimization',
    description: `Once the algorithm is developed, our experts rigorously test it under various market conditions to ensure reliability and efficiency. During this phase, we fine-tune the algorithm, optimizing its performance to align perfectly with your goals while minimizing risks.`,
  },
  'step-4': {
    image: '/img/probuildStep4.png',
    alt: 'step 4 image',
    title: 'Seamless Deployment',
    description: `After rigorous testing, your custom-built algorithm is ready to be executed. We deploy your strategy seamlessly through our platform, providing you with the tools and support needed to monitor and manage it effectively in real-time trading.`,
  },
};

export const quantQuestSteps = {
  'step-1': {
    video: 'https://www.youtube.com/embed/ewUOTSGTSPQ?start=2',
    alt: 'step 1 image',
    title: 'IIT Delhi',
    description: `
    At IIT Delhi, over 450 participants competed over five days, generating extraordinary returns through innovative strategies.
    `,
  },
  'step-2': {
    video: 'https://www.youtube.com/embed/VHDracshZFI?si=SI8NjeJX0PKyxFCx',
    alt: 'step 2 image',
    title: 'IIT Bombay',
    description:
      'In IIT Bombay, 700+ students participated in a 12-day event, learning from industry leaders and achieving unparalleled Gross ROI.',
  },
  'step-3': {
    video: 'https://www.youtube.com/embed/keNaYuKZMhc?si=eLrIy7yeAMgzieVc',
    alt: 'step 3 image',
    title: 'IIT Kanpur',
    description: `IIT Kanpur saw participants with no prior experience generate returns of thousands of crores, proving the power of education and innovation.`,
  },
  'step-4': {
    video: 'https://www.youtube.com/embed/9-YZ1Y3odKg?si=zc5xRiJA-tXBLw8x',
    alt: 'step 4 image',
    title: 'IIT Madras',
    description: `Quant Quest at IIT Madras was one of the most roller coster kind of competition with no clear predictions of the winner since the leaderboard for 750+ participants was continuously changing.`,
  },
  'step-5': {
    video: 'https://www.youtube.com/embed/GRqc8ZJ_mLo?si=CrDe2NFUR0tyZY_3',
    alt: 'step 5 image',
    title: 'IIT BHU',
    description: `Quant Quest at IIT BHU witnessed a dynamic blend of creative and custom-built strategies, as participants leveraged cutting-edge tools to craft innovative solutions, showcasing exceptional talent and adaptability throughout the competition.`,
  },
};

export const pythonBuildPageFeatureList = [
  {
    id: 0,
    title: 'Full Python Flexibility',
    icon: 'flex',
    image: '/img/infra-img.svg',
    description:
      "Write and refine trading strategies using Python without limitations. Enjoy complete control over every aspect of your strategy, from data processing to trade execution, leveraging the full power of Python's extensive libraries.",
  },
  {
    id: 1,
    title: 'Pre-Built Templates',
    image: '/img/platform-img.svg',
    icon: 'coding',
    description:
      'Kickstart your journey with ready-made strategies that you can customise to fit your needs. Modify existing frameworks or create unique trading logic tailored to your market insights, saving time and reducing development effort.',
  },
  {
    id: 2,
    title: 'Seamless Backtesting & Paper Trading',
    icon: 'pricing',
    image: '/img/report-img.svg',
    description:
      'Validate strategies with historical and live market data before deploying real capital. Analyse past performance, identify patterns, and optimise parameters without risking actual funds.',
  },
  {
    id: 3,
    title: 'Automated Execution',
    icon: 'generate',
    image: '/img/strat-exe-img.svg',
    description:
      'Execute and manage strategies directly on the AlgoBulls platform, eliminating manual intervention. Ensure trades are placed accurately and efficiently while reducing emotional decision-making.',
  },
  {
    id: 4,
    title: 'Comprehensive Library Support',
    icon: 'infra',
    image: '/img/market-access-img.svg',
    description:
      'Access a robust ecosystem with QuantLib, TA-Lib, and proprietary AlgoBulls quant functions, plus data science libraries like NumPy, Pandas, SciPy, and Scikit-Learn. These libraries offer pre-built functions for technical indicators, quantitative finance, and advanced analytics.',
  },
  {
    id: 5,
    title: 'Machine Learning',
    icon: 'triangle',
    image: '/img/problem-solving-bro.svg',
    description:
      'Integrate AI-powered models with TensorFlow, Keras, and PyTorch to enhance predictive accuracy. Leverage deep learning for market pattern recognition, trend forecasting, and algorithmic optimisation.',
  },
  {
    id: 6,
    title: 'Jupyter Notebook Integration',
    icon: 'target',
    image: '/img/tailored-target.svg',
    description:
      'Seamlessly develop, test, and refine your trading strategies within an interactive, code-friendly environment. Leverage real-time data analysis, visualisation tools, and step-by-step execution to optimise performance before live deployment.',
  },
  {
    id: 7,
    title: 'Command Line Interface (CLI)',
    icon: 'prebuild',
    image: '/img/development-focus.svg',
    description:
      'Automate executions and manage strategies efficiently with terminal commands. Power users can streamline their workflow with quick command-based deployments and script automation.',
  },
  {
    id: 8,
    title: 'Zero Server Hassles',
    icon: 'support',
    image: '/img/customer-support.svg',
    description:
      'Operate in a fully cloud-based infrastructure, freeing you from managing servers or installations. Focus on developing and refining your strategies while we handle the technical complexities.',
  },
];

export const probuildFeatureList = [
  {
    id: 0,
    icon: 'prebuild',
    title: 'Comprehensive and Flexible Strategy Development',
    image: '/img/development-focus.svg',
    description:
      'Phoenix Pro Build offers complete flexibility in designing a wide range of trading strategies, from automated strategies for Equity and Futures & Options (F&O) to intraday and delivery trading. Whether you are focusing on short-term trades or long-term investments, the platform accommodates both, allowing you to develop algorithms based on your specific logic and trading approach.',
  },
  {
    id: 1,
    icon: 'generate',
    title: 'Multi-Strategy Management and Real-Time Execution',
    image: '/img/time-management.svg',
    description:
      'With Phoenix Pro Build, you can manage multiple strategies for the same instrument within a single account, optimizing your trading opportunities. The platform integrates seamlessly with TradingView and Chartink, allowing you to generate signals automatically and execute trades in real-time. Additionally, advanced screeners help filter market conditions, ensuring precise and efficient strategy execution.',
  },
  {
    id: 2,
    icon: 'triangle',
    title: 'Sophisticated Strategy Optimization',
    image: '/img/problem-solving-bro.svg',
    description:
      'Phoenix Pro Build supports the creation of complex trading models by combining multiple technical indicators like moving averages, RSI, MACD, and Bollinger Bands. It also enables strategy optimization, focusing on market conditions such as mean reversion, trend-following, and momentum, ensuring that your trading strategies remain effective in any market environment.',
  },
  {
    id: 3,
    icon: 'target',
    title: 'Tailored Solutions & Custom Plans',
    image: '/img/tailored-target.svg',
    description:
      'At AlgoBulls, we understand that every trader’s needs are unique. We offer custom plans through Phoenix Pro Build, specifically designed to cater to your exact requirements. You can modify and tweak your strategies with customizable parameters, ensuring flexibility and precision in execution.',
  },
  {
    id: 4,
    icon: 'flex',
    image: '/img/infra-img.svg',

    title: 'Seamless Platform Integration & Automation',
    description:
      'Our algorithms integrate seamlessly with popular charting platforms like TradingView and Chartink. The dedicated middleware we develop allows for easy signal generation and direct execution on AlgoBulls, streamlining the entire process.',
  },
  {
    id: 5,
    icon: 'pricing',
    image: '/img/strat-exe-img.svg',

    title: 'Simulation Environment for Testing',
    description:
      'Before you commit real funds, test your strategies in our robust simulation environment. With Phoenix Pro Build, you can backtest and paper trade your algorithms, gaining confidence in performance before moving to live trading.',
  },
  {
    id: 6,
    icon: 'infra',
    image: '/img/market-access-img.svg',
    title: 'Expert Development Team for Customised Support',
    description:
      'With years of experience in algorithmic trading, our team provides hands-on support throughout the development process. From initial consultation and strategy refinement to coding, testing, and deployment, we ensure your strategy is executed flawlessly.',
  },
  {
    id: 7,
    icon: 'upward',
    title: 'Scalability for Individual and Institutional Clients',
    image: '/img/business-growth.svg',
    description:
      'Rest easy knowing that your valuable data and strategy codes are safeguarded. You retain complete ownership of your intellectual property.',
  },
  {
    id: 8,
    icon: 'support',
    title: 'End-to-End Support for Optimisation and Execution',
    image: '/img/customer-support.svg',

    description:
      'We provide a comprehensive service that includes not only algorithm development but also backtesting, optimisation, and deployment. Our approach ensures that your algorithm performs to its full potential, delivering the precision and efficiency you need.',
  },
];
export const copilotSteps = {
  'step-1': {
    image: '/img/copilotStep1.png',
    alt: 'step 1 image',
    title: 'Create Your Strategy in Plain English',
    description: `Use our Gen AI to turn your trading ideas into full-fledged strategies. Just type in plain English prompt, hit enter, and watch as the strategy code is generated for you.
    `,
  },
  'step-2': {
    image: '/img/copilotStep2.png',
    alt: 'step 2 image',
    title: 'Backtest Your Strategy',
    description:
      'Choose a broker and an instrument to quickly backtest your strategy and see how it performs. You can also customise the test with advanced settings to fine-tune the strategy based on your own parameters.',
  },
  'step-3': {
    image: '/img/copilotStep3.png',
    alt: 'step 3 image',
    title: 'Review Your Backtested Results',
    description: `Check out the results of your backtest using various metrics and charts to see how well your strategy is doing. For a deeper analysis, click on the “Get Advanced Analytics” button to explore more detailed data.`,
  },
  'step-4': {
    image: '/img/copilotStep4.png',
    alt: 'step 4 image',
    title: 'Trade in Live Market',
    description: `Once you're confident that your strategy is optimised and ready, click the “Live Trade in Phoenix” button to start trading in live market and take your trading to the next level.`,
  },
};

export const pythonBuildSteps = {
  'step-1': {
    image: '/img/pythonBuild1.png',
    alt: 'step 1 image',
    title: 'Start Coding',
    description: `Write your trading strategy from scratch or customise an existing template. You can code from your browser without installing Python or any other software/library locally. Alternatively, you can also use Jupyter Notebooks or CLI for seamless coding.`,
  },
  'step-2': {
    image: '/img/pythonBuild2.png',
    alt: 'step 2 image',
    title: 'Test and Optimise',
    description:
      'Conduct backtests with historical and live data, leveraging powerful Python libraries like QuantLib, TA-Lib, Pandas, NumPy, and Scikit-Learn. Identify inefficiencies, optimise parameters, and refine your approach before going live.',
  },
  'step-3': {
    image: '/img/pythonBuild3.png',
    alt: 'step 3 image',
    title: 'Deploy & Automate',
    description: `Execute your strategies effortlessly on the AlgoBulls Phoenix Python Build platform or integrate with external applications using pyalgotrading. Benefit from automated execution, reducing latency and slippage.`,
  },
  'step-4': {
    image: '/img/Phoenix Analytics.png',
    alt: 'step 4 image',
    title: 'Monitor and Scale',
    description: `Analyse performance with built-in reporting tools and scale your strategies for maximum profitability. Continuously refine your approach with real-time insights and analytics.`,
  },
};

export const odysseySteps = {
  'step-1': {
    image: '/img/odysseyStep1.png',
    alt: 'step 1 image',
    title: 'Choose a Strategy',
    description: `Browse through a variety of strategy templates crafted by our experts. Once you find the one you like, just hit the "Add to My Portfolio" button to add it to your “My Portfolio” section.
    `,
  },
  'step-2': {
    image: '/img/odysseyStep2.png',
    alt: 'step 2 image',
    title: 'Adjust Your Strategy',
    description:
      'Customise the strategy to fit your needs by using the “Tweak Config” button in the “Config” column of your strategy in “My Portfolio.” You can tweak options like instruments, order settings, and other parameters to get the best result.',
  },
  'step-3': {
    image: '/img/odysseyStep3.png',
    alt: 'step 3 image',
    title: 'Choose Your Preferred Mode Of Execution',
    description: `Test your strategy with Backtest or Paper Trade option, and then take it for Live Trading. You can switch between these options easily in the same place. Decide on the time frame, lot size, and how much profit or loss you’re comfortable with for your strategy.`,
  },
  'step-4': {
    image: '/img/odysseyStep4.png',
    alt: 'step 4 image',
    title: 'Analyse Your Executed Strategy',
    description: `Use charts and metrics to see how well your strategy performed and find ways to improve it. You can also check detailed logs and order timeline for a deeper dive into optimisation of your strategy.`,
  },
};

export const pythonTestimonials = [
  {
    id: 0,
    comment:
      'Id urna, nisl, ut quam. Diam suspendisse fringilla quam arcu mattis est velit in. Nibh in purus sit convallis phasellus ut. At vel erat ultricies commodo. Neque suspendisse a habitasse commodo.  Id urna, nisl, ut quam. Diam suspendisse fringilla quam arcu mattis est velit in. Nibh in purus sit convallis phasellus ut. At vel erat ultricies commodo. Neque suspendisse a habitasse commodo.',
    user: {
      name: 'Karthik Aryan',
      position: 'Entrepreneur',
      image: '/img/test-1.png',
    },
  },
  {
    id: 2,
    comment:
      'Id urna, nisl, ut quam. Diam suspendisse fringilla quam arcu mattis est velit in. Nibh in purus sit convallis phasellus ut. At vel erat ultricies commodo. Neque suspendisse a habitasse commodo.  Id urna, nisl, ut quam. Diam suspendisse fringilla quam arcu mattis est velit in. Nibh in purus sit convallis phasellus ut. At vel erat ultricies commodo. Neque suspendisse a habitasse commodo.',
    user: {
      name: 'Karthik Aryan',
      position: 'Entrepreneur',
      image: '/img/test-1.png',
    },
  },
  {
    id: 0,
    comment:
      'Id urna, nisl, ut quam. Diam suspendisse fringilla quam arcu mattis est velit in. Nibh in purus sit convallis phasellus ut. At vel erat ultricies commodo. Neque suspendisse a habitasse commodo.  Id urna, nisl, ut quam. Diam suspendisse fringilla quam arcu mattis est velit in. Nibh in purus sit convallis phasellus ut. At vel erat ultricies commodo. Neque suspendisse a habitasse commodo.',
    user: {
      name: 'Karthik Aryan',
      position: 'Entrepreneur',
      image: '/img/test-1.png',
    },
  },
];

export const flags = {
  india: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="#fab446"
        d="M473.655 88.276H38.345C17.167 88.276 0 105.443 0 126.621v73.471h512v-73.471c0-21.178-17.167-38.345-38.345-38.345z"
      />
      <path
        fill="#73af00"
        d="M0 385.379c0 21.177 17.167 38.345 38.345 38.345h435.31c21.177 0 38.345-17.167 38.345-38.345v-73.471H0v73.471z"
      />
      <path fill="#f5f5f5" d="M0 200.09h512V311.9H0z" />
      <g fill="#41479b">
        <path d="M256 303.448c-26.164 0-47.448-21.284-47.448-47.448s21.284-47.448 47.448-47.448 47.448 21.284 47.448 47.448-21.284 47.448-47.448 47.448zm0-86.069c-21.298 0-38.621 17.323-38.621 38.621s17.323 38.621 38.621 38.621 38.621-17.323 38.621-38.621-17.323-38.621-38.621-38.621z" />
        <circle cx="256" cy="256" r="5.379" />
        <path d="M256 256.807l-13.67 1.38-29.364-1.38v-1.614l29.364-1.38 13.67 1.38zM256 256.807l13.67 1.38 29.364-1.38v-1.614l-29.364-1.38-13.67 1.38z" />
        <path d="M255.193 256l-1.38-13.67 1.38-29.364h1.614l1.38 29.364-1.38 13.67zM255.193 256l-1.38 13.67 1.38 29.364h1.614l1.38-29.364-1.38-13.67z" />
        <path d="M255.43 256.57l-10.642-8.689L225 226.141l1.141-1.141 21.74 19.788 8.689 10.642z" />
        <path d="M255.43 256.57l8.689 10.642L285.859 287l1.141-1.141-19.788-21.74-10.642-8.689z" />
        <path d="M255.43 255.43l8.689-10.642L285.859 225l1.141 1.141-19.788 21.74-10.642 8.689z" />
        <path d="M255.43 255.43l-10.642 8.689L225 285.859l1.141 1.141 21.74-19.788 8.689-10.642z" />
        <path d="M256.309 256.746l-12.102 6.506-27.656 9.962-.618-1.491 26.601-12.512 13.157-3.957z" />
        <path d="M256.309 256.746l13.157-3.957 26.601-12.512-.618-1.491-27.656 9.962-12.102 6.506z" />
        <path d="M255.254 256.309l-6.506-12.102-9.962-27.656 1.491-.618 12.512 26.601 3.957 13.157z" />
        <path d="M255.254 256.309l3.957 13.157 12.512 26.601 1.491-.618-9.962-27.656-6.506-12.102z" />
        <path d="M255.691 256.746l-13.157-3.957-26.601-12.512.618-1.491 27.656 9.962 12.102 6.506zM255.691 256.746l12.102 6.506 27.656 9.962.618-1.491-26.601-12.512-13.157-3.957z" />
        <path d="M255.254 255.691l3.957-13.157 12.512-26.601 1.491.618-9.962 27.656-6.506 12.102zM255.254 255.691l-6.506 12.102-9.962 27.656 1.491.618 12.512-26.601 3.957-13.157z" />
      </g>
      <circle cx="256" cy="256" r="7.256" fill="#f5f5f5" />
      <circle cx="256" cy="256" r="4.351" fill="#41479b" />
    </svg>
  ),
  'united-states': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="#f5f5f5"
        d="M473.655 88.276H38.345C17.167 88.276 0 105.443 0 126.621V385.38c0 21.177 17.167 38.345 38.345 38.345h435.31c21.177 0 38.345-17.167 38.345-38.345V126.621c0-21.178-17.167-38.345-38.345-38.345z"
      />
      <g fill="#ff4b55">
        <path d="M2.109 114.08H509.89c-5.196-15.017-19.452-25.804-36.235-25.804H38.345c-16.784 0-31.039 10.787-36.236 25.804zM0 191.49h512v25.803H0zM0 139.88h512v25.803H0zM0 260.074a8.829 8.829 0 008.828 8.828H512v-25.804H0v16.976zM0 346.32h512v25.804H0zM509.891 397.92H2.109c5.197 15.017 19.453 25.804 36.236 25.804h435.31c16.784 0 31.039-10.787 36.236-25.804zM0 294.71h512v25.803H0z" />
      </g>
      <path
        fill="#41479b"
        d="M8.828 268.902h220.69a8.829 8.829 0 008.828-8.828V97.103a8.828 8.828 0 00-8.828-8.828H38.345C17.167 88.276 0 105.443 0 126.621v133.453a8.828 8.828 0 008.828 8.828z"
      />
      <g fill="#f5f5f5">
        <path d="M24.789 108.537l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.669 1.864 5.889c.242.762-.627 1.394-1.278.928L24 122.841l-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.669c-.643-.476-.312-1.496.488-1.502l6.177-.047 1.954-5.86c.252-.76 1.324-.76 1.578-.001zM24.789 139.191l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928L24 153.496l-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.324-.759 1.578-.001zM24.789 169.846l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928L24 184.151l-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.76 1.324-.76 1.578-.001zM24.789 200.5l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928L24 214.805l-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.76 1.324-.76 1.578-.001zM24.789 231.154l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928L24 245.459l-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.324-.759 1.578-.001zM48.582 123.566l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.325-.758 1.578 0zM48.582 154.221l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM48.582 184.875l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM48.582 215.529l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.325-.758 1.578 0zM72.375 108.537l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.669 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.669c-.643-.476-.312-1.496.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM72.375 139.191l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.325-.758 1.578 0zM72.375 169.846l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM72.375 200.5l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM72.375 231.154l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.325-.758 1.578 0zM96.169 123.566l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.758 1.325-.758 1.578 0zM96.169 154.221l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.759 1.325-.759 1.578 0zM96.169 184.875l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.759 1.325-.759 1.578 0zM96.169 215.529l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.758 1.325-.758 1.578 0zM119.962 108.537l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.669 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.026-3.591-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.669c-.643-.476-.312-1.496.488-1.502l6.177-.047 1.954-5.86c.253-.76 1.326-.76 1.579-.001zM119.962 139.191l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.026-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.758 1.326-.758 1.579 0zM119.962 169.846l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.026-3.593-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.758 1.326-.758 1.579.001zM119.962 200.5l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.026-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.759 1.326-.759 1.579 0zM119.962 231.154l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.026-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.758 1.326-.758 1.579 0zM143.755 123.566l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.758 1.325-.758 1.578 0zM143.755 154.221l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.759 1.325-.759 1.578 0zM143.755 184.875l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.759 1.325-.759 1.578 0zM143.755 215.529l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.253-.758 1.325-.758 1.578 0zM167.549 108.537l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.669 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.669c-.643-.476-.312-1.496.488-1.502l6.177-.047 1.954-5.86c.251-.759 1.325-.759 1.578 0zM167.549 139.191l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.758 1.325-.758 1.578 0zM167.549 169.846l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.759 1.325-.759 1.578 0zM167.549 200.5l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.759 1.325-.759 1.578 0zM167.549 231.154l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.251-.758 1.325-.758 1.578 0zM191.342 123.566l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.325-.758 1.578 0zM191.342 154.221l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM191.342 184.875l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.325-.759 1.578 0zM191.342 215.529l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.325-.758 1.578 0zM215.136 108.537l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.669 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.466-1.518-.166-1.278-.928l1.864-5.889-4.969-3.669c-.643-.476-.312-1.496.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.324-.759 1.578 0zM215.136 139.191l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.324-.758 1.578 0zM215.136 169.846l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.165-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.324-.759 1.578 0zM215.136 200.5l1.954 5.86 6.177.047c.8.007 1.131 1.027.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.474-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.759 1.324-.759 1.578 0zM215.136 231.154l1.954 5.86 6.177.047c.8.007 1.131 1.026.488 1.502l-4.969 3.67 1.864 5.889c.242.762-.627 1.394-1.278.928l-5.025-3.592-5.025 3.592c-.651.465-1.518-.166-1.278-.928l1.864-5.889-4.969-3.67c-.643-.476-.312-1.495.488-1.502l6.177-.047 1.954-5.86c.252-.758 1.324-.758 1.578 0z" />
      </g>
    </svg>
  ),
};

const pythonBuildStats = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101"
        height="101"
        viewBox="0 0 101 101"
        fill="none">
        <rect
          x="0.304688"
          y="0.09375"
          width="100.001"
          height="100.001"
          rx="21.0528"
          fill="#2C78F6"
        />
        <path
          d="M41.9545 58.7323V49.0693C41.9545 47.8024 40.9274 46.7754 39.6606 46.7754H33.4657C32.1989 46.7754 31.1719 47.8024 31.1719 49.0693V60.2926C34.1574 60.1914 37.8678 59.647 41.9545 58.7323Z"
          fill="white"
        />
        <path
          d="M60.6562 57.1284V71.1482H71.4389V51.7832C68.3395 53.6104 64.6879 55.4264 60.6562 57.1284Z"
          fill="white"
        />
        <path
          d="M39.9268 65.96H41.9467V63.3047C38.0971 64.2363 34.4463 64.8958 31.1641 65.2491V71.1464H41.9467V68.5616L39.9268 65.96Z"
          fill="white"
        />
        <path
          d="M52.401 60.2562C50.1675 61.0153 47.9492 61.7008 45.7734 62.3081V65.961H47.9809L45.7734 68.8042V71.1474H56.5561V58.7617C55.2008 59.2757 53.8152 59.7757 52.401 60.2562Z"
          fill="white"
        />
        <path
          d="M54.6596 44.2802L56.5561 41.8375V41.2312C56.5561 40.0508 55.599 39.0938 54.4186 39.0938H47.9109C46.7303 39.0938 45.7734 40.0508 45.7734 41.2312V57.7956C48.3314 57.1187 50.9851 56.3187 53.6614 55.4089C54.6516 55.0723 55.6154 54.7304 56.5561 54.385V44.28L54.6596 44.2802Z"
          fill="white"
        />
        <path
          d="M60.6328 31.7962V41.6135L62.7027 44.2796H60.6328V52.7977C64.9323 51.0323 68.5654 49.2216 71.4154 47.5279V31.7964C71.4154 30.2747 70.1818 29.041 68.6602 29.041H63.3882C61.8663 29.041 60.6328 30.2747 60.6328 31.7962Z"
          fill="white"
        />
        <path
          d="M82.0101 38.2637L76.0661 42.5636L79.1384 42.5601C76.845 46.4066 66.778 52.0821 54.0051 56.4237C38.6806 61.6327 25.2694 62.9479 24.0501 59.3612C23.4669 57.6457 25.7809 55.1196 30.0281 52.381V49.3535C21.5852 53.8835 16.5278 58.553 17.5532 61.5697C19.1347 66.2225 34.5814 65.1799 52.0544 59.2408C66.3811 54.371 77.6189 47.722 80.3303 42.9202L82.0193 45.1093L82.0101 38.2637Z"
          fill="white"
        />
      </svg>
    ),
    prefix: '$',
    value: 5,
    suffix: '+ Billion',
    title: 'Trading Volume',
    tooltip: "Turnover across all segments, with Options' Premium Turnover",
  },
  {
    icon: (
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          x="0.000976562"
          width="100.001"
          height="100.001"
          rx="21.0528"
          fill="#2C78F6"
        />
        <g clipPath="url(#clip0_1741_498)">
          <path
            d="M36.8304 54.3892H31.6298C31.0092 54.3892 30.5127 54.8856 30.5127 55.5062V57.6659V67.1736V69.3333C30.5127 69.9539 31.0092 70.4504 31.6298 70.4504H36.8304C37.4511 70.4504 37.9475 69.9539 37.9475 69.3333V67.1736V57.6659V55.5062C37.9599 54.8856 37.4511 54.3892 36.8304 54.3892Z"
            fill="white"
          />
          <path
            d="M47.3436 48.1709H42.143C41.5224 48.1709 41.0259 48.6674 41.0259 49.288V57.6661V60.9429V69.3211C41.0259 69.9417 41.5224 70.4382 42.143 70.4382H47.3436C47.9642 70.4382 48.4607 69.9417 48.4607 69.3211V60.9429V57.6661V49.288C48.4607 48.6674 47.9642 48.1709 47.3436 48.1709Z"
            fill="white"
          />
          <path
            d="M58.9742 51.4851V42.2257H62.5737C63.2315 42.2257 63.6411 41.4933 63.2936 40.9348L55.9704 29.1806C55.6353 28.6468 54.8658 28.6468 54.5306 29.1806L47.2075 40.9348C46.86 41.4933 47.2572 42.2257 47.9274 42.2257H51.5269V69.3336C51.5269 69.9543 52.0234 70.4507 52.644 70.4507H57.8447C58.4653 70.4507 58.9618 69.9543 58.9618 69.3336C56.8765 66.9381 55.5981 63.8227 55.5981 60.3969C55.6229 56.9959 56.8889 53.8682 58.9742 51.4851Z"
            fill="white"
          />
          <path
            d="M69.2013 49.623C63.2435 49.623 58.4028 54.4513 58.4028 60.4216C58.4028 66.3794 63.2311 71.2201 69.2013 71.2201C75.1591 71.2201 79.9999 66.3918 79.9999 60.4216C79.9999 54.4513 75.1716 49.623 69.2013 49.623ZM72.3044 64.6665C71.8327 65.2374 71.2245 65.6222 70.5046 65.8208C70.1943 65.9077 70.0578 66.0691 70.0702 66.3918C70.0826 66.7145 70.0702 67.0248 70.0702 67.3475C70.0702 67.633 69.9212 67.7819 69.6482 67.7943C69.3006 67.8067 68.9655 67.8067 68.618 67.7943C68.3201 67.7943 68.1711 67.6206 68.1711 67.3227C68.1711 67.0868 68.1711 66.851 68.1587 66.6276C68.1587 66.1187 68.1339 66.0939 67.6374 66.0194C67.0044 65.9201 66.3838 65.7712 65.8004 65.4981C65.3412 65.2747 65.304 65.163 65.4281 64.6913C65.5274 64.3314 65.6267 63.9838 65.7384 63.6363C65.8625 63.2267 65.9742 63.177 66.3466 63.3756C66.992 63.7108 67.6622 63.8969 68.3821 63.9838C68.8414 64.0459 69.2882 63.9962 69.7102 63.8101C70.5046 63.4625 70.6287 62.544 69.9585 61.9855C69.7351 61.7993 69.4744 61.6628 69.2013 61.5386C68.5063 61.2283 67.774 61.0049 67.1285 60.6077C66.0611 59.9747 65.3908 59.0935 65.4653 57.7902C65.5522 56.3256 66.3838 55.4071 67.7243 54.923C68.2829 54.7244 68.2829 54.7244 68.2829 54.1535C68.2829 53.9549 68.2829 53.7563 68.2829 53.5701C68.2953 53.1357 68.3697 53.0612 68.8042 53.0488C68.9407 53.0488 69.0772 53.0488 69.2138 53.0488C70.1447 53.0488 70.1447 53.0488 70.1447 53.9797C70.1447 54.6375 70.1447 54.6375 70.8025 54.7368C71.299 54.8113 71.7831 54.9602 72.2423 55.1712C72.503 55.283 72.5898 55.4567 72.5154 55.7298C72.4037 56.127 72.292 56.5366 72.1678 56.9338C72.0437 57.3061 71.932 57.3682 71.5721 57.1944C70.8522 56.8469 70.095 56.6979 69.2882 56.7476C69.0772 56.76 68.8786 56.7848 68.68 56.8717C67.985 57.1696 67.8733 57.9391 68.469 58.4108C68.7669 58.6466 69.102 58.8204 69.462 58.9693C70.0702 59.2176 70.6908 59.4658 71.2742 59.7885C73.1112 60.7567 73.6076 63.0902 72.3044 64.6665Z"
            fill="white"
          />
          <path
            d="M26.3177 61.8984H21.1171C20.4965 61.8984 20 62.3949 20 63.0155V63.2265V65.1752V67.1736V67.9183V69.3333C20 69.9539 20.4965 70.4504 21.1171 70.4504H26.3177C26.9384 70.4504 27.4348 69.9539 27.4348 69.3333V67.9183V67.1736V65.1752V63.4996V63.0155C27.4472 62.3949 26.9384 61.8984 26.3177 61.8984Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1741_498">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(20 20)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    prefix: '$',
    value: 500,
    suffix: '+ Billion',
    title: 'Total Turnover',
    tooltip: "Turnover across all segments, with Options' Notional Turnover",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101"
        height="101"
        viewBox="0 0 101 101"
        fill="none">
        <rect
          x="0.945312"
          y="0.09375"
          width="100.001"
          height="100.001"
          rx="21.0528"
          fill="#2C78F6"
        />
        <path
          d="M72.8951 41.327C72.8073 41.1076 72.7152 40.8882 72.6208 40.6688C71.2053 37.4043 68.9145 34.5949 66.0018 32.5513H70.7012C71.1666 32.5513 71.6131 32.3664 71.9422 32.0372C72.2714 31.7081 72.4563 31.2616 72.4563 30.7962C72.4563 30.3307 72.2714 29.8842 71.9422 29.5551C71.6131 29.2259 71.1666 29.041 70.7012 29.041H47.8844C43.0317 29.0472 38.3587 30.8781 34.7935 34.1702C31.2282 37.4624 29.0314 41.9749 28.6393 46.8118C27.1233 47.1886 25.7762 48.0604 24.8114 49.2891C23.8465 50.5178 23.3191 52.0331 23.3125 53.5954C23.3125 54.0608 23.4974 54.5073 23.8266 54.8364C24.1557 55.1656 24.6021 55.3505 25.0676 55.3505C25.5331 55.3505 25.9796 55.1656 26.3087 54.8364C26.6379 54.5073 26.8228 54.0608 26.8228 53.5954C26.8232 52.9553 26.9986 52.3276 27.33 51.7801C27.6613 51.2325 28.1361 50.786 28.703 50.4888C29.1398 54.4265 30.7818 58.1334 33.4045 61.1029L36.1601 68.8168C36.4037 69.4991 36.8525 70.0893 37.4448 70.5064C38.0371 70.9236 38.744 71.1472 39.4685 71.1467H42.2592C42.9833 71.1468 43.6897 70.9229 44.2816 70.5058C44.8735 70.0887 45.3219 69.4987 45.5654 68.8168L45.9867 67.6364H58.5578L58.979 68.8168C59.2225 69.4987 59.671 70.0887 60.2629 70.5058C60.8548 70.9229 61.5612 71.1468 62.2853 71.1467H65.076C65.8001 71.1468 66.5065 70.9229 67.0984 70.5058C67.6903 70.0887 68.1387 69.4987 68.3822 68.8168L71.9385 58.8608H72.4563C73.8528 58.8608 75.192 58.306 76.1795 57.3186C77.167 56.3311 77.7217 54.9918 77.7217 53.5954V46.5748C77.7219 45.2542 77.2258 43.9817 76.3318 43.0096C75.4378 42.0376 74.2111 41.437 72.8951 41.327ZM56.6601 37.7991H47.8844C47.4189 37.7991 46.9725 37.6142 46.6433 37.2851C46.3142 36.9559 46.1293 36.5095 46.1293 36.044C46.1293 35.5785 46.3142 35.1321 46.6433 34.8029C46.9725 34.4738 47.4189 34.2889 47.8844 34.2889H56.6601C57.1256 34.2889 57.572 34.4738 57.9011 34.8029C58.2303 35.1321 58.4152 35.5785 58.4152 36.044C58.4152 36.5095 58.2303 36.9559 57.9011 37.2851C57.572 37.6142 57.1256 37.7991 56.6601 37.7991ZM62.8031 50.0851C62.2823 50.0851 61.7733 49.9307 61.3404 49.6414C60.9075 49.3521 60.57 48.9409 60.3708 48.4599C60.1715 47.9788 60.1194 47.4495 60.2209 46.9388C60.3225 46.4281 60.5733 45.959 60.9414 45.5908C61.3096 45.2226 61.7787 44.9718 62.2894 44.8703C62.8001 44.7687 63.3295 44.8208 63.8105 45.0201C64.2916 45.2193 64.7028 45.5568 64.9921 45.9897C65.2813 46.4227 65.4358 46.9317 65.4358 47.4524C65.4358 48.1506 65.1584 48.8203 64.6646 49.314C64.1709 49.8077 63.5013 50.0851 62.8031 50.0851Z"
          fill="white"
        />
      </svg>
    ),
    value: 3,
    suffix: '+ Million',
    title: 'Live Orders',
    tooltip: 'Live Orders',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101"
        height="101"
        viewBox="0 0 101 101"
        fill="none">
        <rect
          x="0.585938"
          y="0.09375"
          width="100.001"
          height="100.001"
          rx="21.0528"
          fill="#2C78F6"
        />
        <path
          d="M33.2046 54.0224C33.2121 54.1722 33.1891 54.3221 33.1369 54.4627C33.0846 54.6034 33.0043 54.7319 32.9008 54.8406C32.7974 54.9492 32.6728 55.0357 32.5349 55.0947C32.3969 55.1537 32.2484 55.1841 32.0983 55.1839H19.8958C19.3964 55.1846 18.9115 55.0164 18.5198 54.7066C18.1281 54.3969 17.8528 53.9637 17.7385 53.4776C17.6674 53.1449 17.6707 52.8006 17.7481 52.4693C17.8256 52.138 17.9753 51.8279 18.1866 51.5612C20.1387 48.9727 22.7288 46.9346 25.7039 45.6459C24.3977 44.4552 23.3959 42.9688 22.7824 41.3113C22.1688 39.6537 21.9615 37.8734 22.1776 36.1192C22.3937 34.3651 23.0271 32.6883 24.0246 31.2292C25.0222 29.7702 26.3549 28.5714 27.9111 27.7332C29.4673 26.895 31.2017 26.4419 32.969 26.4118C34.7364 26.3816 36.4852 26.7754 38.0691 27.56C39.653 28.3447 41.0257 29.4974 42.0724 30.9216C43.1192 32.3458 43.8093 34 44.0851 35.7458C44.1207 35.9805 44.0787 36.2205 43.9654 36.4291C43.852 36.6378 43.6736 36.8037 43.4573 36.9017C40.3884 38.3203 37.7893 40.587 35.9668 43.4344C34.1443 46.2817 33.1744 49.591 33.1715 52.9715C33.1715 53.3255 33.1715 53.6739 33.2046 54.0224ZM83.5414 51.5584C81.5939 48.9729 79.0097 46.9359 76.0407 45.6459C77.3469 44.4552 78.3487 42.9688 78.9622 41.3113C79.5758 39.6537 79.7831 37.8734 79.567 36.1192C79.3509 34.3651 78.7175 32.6883 77.72 31.2292C76.7224 29.7702 75.3897 28.5714 73.8335 27.7332C72.2773 26.895 70.5429 26.4419 68.7756 26.4118C67.0082 26.3816 65.2594 26.7754 63.6755 27.56C62.0916 28.3447 60.7189 29.4974 59.6722 30.9216C58.6255 32.3458 57.9353 34 57.6595 35.7458C57.6239 35.9805 57.6659 36.2205 57.7792 36.4291C57.8926 36.6378 58.071 36.8037 58.2873 36.9017C61.3562 38.3203 63.9553 40.587 65.7778 43.4344C67.6003 46.2817 68.5702 49.591 68.5732 52.9715C68.5732 53.3255 68.5732 53.6739 68.54 54.0224C68.5325 54.1722 68.5555 54.3221 68.6078 54.4627C68.66 54.6034 68.7403 54.7319 68.8438 54.8406C68.9473 54.9492 69.0718 55.0357 69.2097 55.0947C69.3477 55.1537 69.4962 55.1841 69.6463 55.1839H81.8488C82.3482 55.1846 82.8332 55.0164 83.2248 54.7066C83.6165 54.3969 83.8918 53.9637 84.0061 53.4776C84.0777 53.1443 84.0743 52.7992 83.9964 52.4673C83.9184 52.1355 83.7678 51.825 83.5553 51.5584H83.5414ZM58.9262 63.4995C61.1292 61.8125 62.7482 59.4776 63.5556 56.8231C64.363 54.1686 64.3182 51.3278 63.4274 48.7C62.5367 46.0723 60.8448 43.7897 58.5896 42.173C56.3344 40.5564 53.6292 39.687 50.8543 39.687C48.0794 39.687 45.3742 40.5564 43.119 42.173C40.8638 43.7897 39.172 46.0723 38.2812 48.7C37.3905 51.3278 37.3457 54.1686 38.153 56.8231C38.9604 59.4776 40.5794 61.8125 42.7825 63.4995C38.8732 65.1931 35.6088 68.0936 33.4674 71.7764C33.2732 72.1127 33.1709 72.4943 33.171 72.8826C33.171 73.271 33.2733 73.6526 33.4675 73.9889C33.6618 74.3252 33.9412 74.6045 34.2776 74.7986C34.614 74.9928 34.9956 75.0949 35.3841 75.0949H66.3605C66.749 75.0949 67.1306 74.9928 67.467 74.7986C67.8034 74.6045 68.0828 74.3252 68.2771 73.9889C68.4713 73.6526 68.5736 73.271 68.5736 72.8826C68.5737 72.4943 68.4714 72.1127 68.2772 71.7764C66.1312 68.0912 62.8608 65.1905 58.9455 63.4995H58.9262Z"
          fill="white"
        />
      </svg>
    ),
    value: 60,
    suffix: 'K+',
    title: 'Direct Clients',
    tooltip: 'Total clients using our platform directly across USA & India',
  },
  {
    icon: (
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="100.001" height="100.001" rx="21.0528" fill="#2C78F6" />
        <path
          d="M58.6529 31.6242C61.9689 31.6242 64.6548 28.7979 64.6548 25.3119C64.6548 21.8258 61.9679 19.0005 58.6529 19.0005C55.3392 19.0005 52.6523 21.8263 52.6523 25.3119C52.6514 28.7979 55.3392 31.6242 58.6529 31.6242Z"
          fill="white"
        />
        <path
          d="M65.667 52.8488V54.0576H60.6904V66.9983H77.354V54.0576H72.3774V52.8488C72.3774 52.2607 71.922 51.7813 71.3624 51.7813H71.267C71.3516 51.4628 71.376 51.1226 71.3281 50.7745C69.9337 40.7805 67.8238 36.5005 62.6454 33.1607C62.544 33.096 62.4397 33.0496 62.3341 33.0022C61.6651 32.5331 60.9149 32.1884 60.1482 31.9899L58.6529 33.573L57.2036 31.9727C57.1989 31.9736 57.1937 31.9736 57.189 31.9761C56.0805 32.2546 55.0021 32.8456 54.1589 33.6762C53.5002 34.1428 52.9045 34.6356 52.3495 35.1595C50.8603 36.2176 49.6049 37.5592 48.3894 38.8632C45.5931 41.8614 43.7063 43.6805 40.3701 43.3807C38.9076 43.2519 37.6306 44.3826 37.5053 45.9138C37.4517 46.5631 37.6165 47.1788 37.9334 47.684C37.787 47.679 37.6424 47.6721 37.4954 47.6721C29.3076 47.6721 22.646 54.6777 22.646 63.2891C22.646 71.9 29.3071 78.9066 37.4954 78.9066C45.6828 78.9066 52.3444 71.901 52.3444 63.2891C52.3444 56.7427 48.4932 51.128 43.0509 48.8103C47.1946 48.0903 49.9068 45.186 52.1674 42.7606C52.1998 42.725 52.2336 42.69 52.2664 42.6544C52.3974 43.0949 52.5101 43.6938 52.5101 43.6938V51.4095C52.5101 52.0682 52.6312 52.6834 52.8458 53.2498C52.8289 53.3771 52.8176 53.5065 52.8176 53.6374L52.8185 77.1033C52.8185 78.7027 54.0519 79.9993 55.5721 79.9993C57.0937 79.9993 58.3256 78.7027 58.3256 77.1024L58.3247 56.9644C58.4336 56.9693 58.5425 56.9787 58.6515 56.9787C58.674 56.9787 58.6946 56.9753 58.7177 56.9753L58.7158 77.1033C58.7158 78.7027 59.9496 79.9993 61.4693 79.9993C62.99 79.9993 64.2233 78.7027 64.2233 77.1033V67.9799H59.8421V53.2567H64.4562C64.6726 52.6898 64.7952 52.0736 64.7952 51.41V42.9689C65.5412 44.9267 66.1764 47.6158 66.7158 51.485C66.7295 51.5872 66.7586 51.6835 66.7839 51.7813H66.6806C66.1219 51.7813 65.667 52.2602 65.667 52.8488ZM30.0376 74.3629L30.0371 67.2097C30.0756 67.2126 30.1146 67.2156 30.154 67.2156C30.1615 67.2156 30.1686 67.2136 30.1766 67.2136V74.3703C30.1766 74.4054 30.1831 74.4399 30.1864 74.4745C30.1357 74.4375 30.0869 74.399 30.0376 74.3629ZM30.1583 63.3335H30.1484L29.6338 62.5934L30.1484 58.976H30.1583L30.6728 62.5934L30.1583 63.3335ZM31.5245 75.3218C31.8818 75.1683 32.1348 74.7999 32.1348 74.3688L32.1353 66.1698C32.1949 66.2379 32.2658 66.2982 32.3484 66.3446C32.4742 66.4167 32.6095 66.4507 32.7433 66.4507C33.0165 66.4507 33.2808 66.307 33.4372 66.0532C33.4743 66.1273 33.5071 66.2019 33.547 66.2774C33.7245 66.6211 34.0611 66.8161 34.409 66.8161C34.5667 66.8161 34.7273 66.7756 34.8761 66.6907C34.9283 66.6606 34.9757 66.6265 35.0198 66.589L35.0207 76.1844C35.0207 76.3424 35.0517 76.4921 35.1038 76.6298C33.8353 76.3795 32.6334 75.9336 31.5245 75.3218ZM32.608 63.459C32.5639 63.7626 32.4775 64.093 32.3376 64.4534V61.7792C32.4376 61.9619 32.5156 62.1599 32.5677 62.3732C32.5465 62.7134 32.5588 63.0753 32.608 63.459ZM34.8907 61.2824V64.4593C34.355 63.0773 34.4606 62.0685 34.8907 61.2824ZM37.4959 76.8668C37.3776 76.8668 37.2607 76.8619 37.1438 76.8579C37.2663 76.6639 37.3372 76.4328 37.3372 76.1839L37.3367 67.7128C37.3832 67.7148 37.4283 67.7187 37.4743 67.7187C37.4837 67.7187 37.4926 67.7187 37.502 67.7187V76.1849C37.502 76.4348 37.5738 76.6683 37.6978 76.8629C37.6297 76.8634 37.563 76.8668 37.4959 76.8668ZM37.4809 63.1286H37.4691L36.8602 62.2527L37.4691 57.9727H37.4809L38.0893 62.2527L37.4809 63.1286ZM39.7264 76.6604C39.7856 76.5138 39.818 76.3528 39.818 76.1839L39.8184 66.4833C39.8889 66.5643 39.9734 66.6359 40.0701 66.6912C40.2194 66.7761 40.3795 66.8166 40.5377 66.8166C40.8851 66.8166 41.2222 66.6211 41.3997 66.2779C41.4382 66.2029 41.471 66.1303 41.5077 66.0572C41.6645 66.309 41.9269 66.4517 42.1997 66.4517C42.333 66.4517 42.4687 66.4181 42.595 66.3456C42.6382 66.3199 42.6786 66.2917 42.7161 66.2591L42.7171 74.3703C42.7171 74.835 43.0114 75.2241 43.4138 75.351C42.2729 75.9726 41.033 76.4205 39.7264 76.6604ZM40.0588 64.4524V61.2893C40.4846 62.0715 40.5903 63.0763 40.0588 64.4524ZM42.3781 62.3613C42.4307 62.15 42.5086 61.9549 42.6072 61.7747V64.4593C42.4687 64.1014 42.3818 63.7745 42.3372 63.4728C42.3884 63.0798 42.4001 62.7094 42.3781 62.3613ZM44.6532 74.5831C44.6673 74.5135 44.6748 74.4434 44.6748 74.3688L44.6743 67.2092C44.7128 67.2111 44.7518 67.2141 44.7912 67.2141C44.7988 67.2141 44.8058 67.2131 44.8138 67.2131L44.8133 74.3688C44.8133 74.4004 44.8199 74.4306 44.8227 74.4607C44.7668 74.5012 44.7105 74.5427 44.6532 74.5831ZM44.7964 63.3335H44.7866L44.2715 62.5934L44.7866 58.976H44.7964L45.3114 62.5934L44.7964 63.3335ZM50.4058 63.2891C50.4058 66.9499 49.0185 70.274 46.772 72.7192L46.7725 66.1698C46.8321 66.2379 46.903 66.2982 46.9847 66.3446C47.1115 66.4167 47.2462 66.4507 47.3805 66.4507C47.6739 66.4507 47.9584 66.2868 48.1086 65.9955C50.4462 61.4775 47.2579 59.4214 46.2105 58.7454C46.1744 58.7217 46.1368 58.7054 46.0997 58.6891C45.8617 58.5217 45.595 58.3988 45.3232 58.3292L44.7917 58.8916L44.2757 58.3218C44.2743 58.3237 44.2715 58.3237 44.2706 58.3237C43.9922 58.3944 43.7199 58.5193 43.4781 58.6896C43.4415 58.7064 43.4044 58.7217 43.3692 58.7454C42.9767 58.9982 42.2847 59.4441 41.695 60.1403C40.9372 58.8521 39.7513 58.0843 39.1541 57.6996C39.1114 57.6715 39.0668 57.6522 39.0231 57.632C38.7414 57.4364 38.4264 57.2898 38.1039 57.2073L37.4743 57.8734L36.8649 57.2004C36.8625 57.2019 36.8602 57.2019 36.8588 57.2024C36.5297 57.2844 36.2071 57.433 35.9217 57.6354C35.878 57.6552 35.8344 57.673 35.7926 57.7006C35.1949 58.0862 34.0076 58.8541 33.2494 60.1443C32.6592 59.4471 31.9667 58.9997 31.5733 58.7464C31.5371 58.7222 31.5001 58.7064 31.4625 58.6901C31.2254 58.5227 30.9583 58.3998 30.686 58.3302L30.155 58.8921L29.6395 58.3228C29.6371 58.3237 29.6353 58.3237 29.6334 58.3247C29.3559 58.3948 29.0836 58.5203 28.8414 58.6901C28.8047 58.7069 28.7672 58.7227 28.7324 58.7459C27.685 59.4209 24.4967 61.477 26.8343 65.9965C26.9841 66.2868 27.2686 66.4517 27.5625 66.4517C27.6963 66.4517 27.832 66.4181 27.9578 66.3456C28.0019 66.3199 28.0423 66.2917 28.0794 66.2591L28.0798 72.5651C25.9155 70.1357 24.5864 66.8744 24.5864 63.2896C24.5864 55.8025 30.377 49.7119 37.4968 49.7119C44.6147 49.7114 50.4058 55.8016 50.4058 63.2891ZM46.9758 64.4524V61.7782C47.3359 62.4408 47.4246 63.2891 46.9758 64.4524ZM27.9695 61.7742V64.4584C27.5165 63.2891 27.6061 62.4378 27.9695 61.7742ZM58.6669 46.0654H58.6392L57.1918 43.9817L58.312 36.1006C58.4247 35.7836 58.4726 35.4468 58.4543 35.1066L58.6402 33.807H58.6674L60.1163 43.9812L58.6669 46.0654ZM67.2121 52.673C67.645 53.2335 68.3036 53.5806 69.0196 53.5806C69.1323 53.5806 69.2459 53.5717 69.36 53.5544C69.9623 53.4616 70.4746 53.1327 70.829 52.673H71.3628C71.4563 52.673 71.53 52.752 71.53 52.8483V54.0571H66.5144V52.8483C66.5144 52.752 66.5895 52.673 66.6811 52.673H67.2121Z"
          fill="white"
        />
        <path
          d="M37.4744 57.0527C38.8684 57.0527 39.9984 55.8642 39.9984 54.3982C39.9984 52.9321 38.8684 51.7437 37.4744 51.7437C36.0805 51.7437 34.9504 52.9321 34.9504 54.3982C34.9504 55.8642 36.0805 57.0527 37.4744 57.0527Z"
          fill="white"
        />
        <path
          d="M44.7913 58.1988C45.9698 58.1988 46.9251 57.1941 46.9251 55.9546C46.9251 54.7152 45.9698 53.7104 44.7913 53.7104C43.6128 53.7104 42.6575 54.7152 42.6575 55.9546C42.6575 57.1941 43.6128 58.1988 44.7913 58.1988Z"
          fill="white"
        />
        <path
          d="M30.1546 58.1988C31.333 58.1988 32.2884 57.1941 32.2884 55.9546C32.2884 54.7152 31.333 53.7104 30.1546 53.7104C28.9761 53.7104 28.0208 54.7152 28.0208 55.9546C28.0208 57.1941 28.9761 58.1988 30.1546 58.1988Z"
          fill="white"
        />
      </svg>
    ),
    value: 200,
    suffix: 'K+',
    title: 'Clients Across Enterprises',
    tooltip:
      'Total clients having access to our platform either directly or via our Enterprise partners',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="101"
        height="101"
        viewBox="0 0 101 101"
        fill="none">
        <rect
          x="0.234375"
          y="0.09375"
          width="100.001"
          height="100.001"
          rx="21.0528"
          fill="#2C78F6"
        />
        <path
          d="M70.7625 66.8225C70.6619 65.243 70.8675 63.5791 70.4297 62.1026C69.8662 60.1958 70.0401 58.3184 69.9828 56.425C69.9469 55.2152 69.4904 54.3983 68.3044 54.0455C65.916 53.3353 63.7036 52.2843 61.5682 50.9735C60.0139 50.0201 58.7006 48.8882 57.4861 47.5633C57.0162 47.0507 55.7225 46.3491 55.7225 46.3491C55.7225 46.3491 56.5477 49.7812 55.9222 51.1055C55.0547 52.9414 53.5433 57.8904 52.2389 62.4204L52.8589 56.4118C52.8654 56.3542 52.8531 56.2937 52.8249 56.2388L51.5095 53.6522L52.5405 50.9183C52.5755 50.8257 52.5567 50.7159 52.4923 50.6281C52.4273 50.5401 52.3245 50.487 52.2211 50.487H51.1827L55.2688 47.6179V46.2525C56.6103 44.8699 57.6064 41.4743 57.6064 41.4743C57.6064 41.4743 58.0079 41.439 57.9907 40.5513C57.9727 39.6638 59.4924 36.232 58.3187 35.6562C58.3187 35.6562 58.0677 35.6243 58.2742 34.8212C59.654 29.4651 57.4134 27.4347 55.5054 27.3936C55.1406 26.7711 54.7228 26.6092 54.7228 26.6092C54.9722 26.7567 55.2029 27.0705 55.3747 27.3558L55.221 27.3034C54.0215 25.918 52.8979 25.8226 52.8979 25.8226C53.535 25.9852 54.2488 26.5794 54.7553 27.0736C54.135 26.6178 51.8432 25.0938 48.909 25.0938C48.9053 25.0938 48.901 25.0938 48.8974 25.0938C48.894 25.0938 48.8903 25.0938 48.8869 25.0938C45.8555 25.0938 40.3899 27.7767 42.2038 34.8212C42.4112 35.6243 42.1602 35.6562 42.1602 35.6562C40.9859 36.232 42.5056 39.6638 42.4885 40.5513C42.4707 41.439 42.8719 41.4743 42.8719 41.4743C42.8719 41.4743 43.868 44.8699 45.2098 46.2525V47.6179L49.2965 50.487H48.2571C48.1538 50.487 48.0519 50.5401 47.9866 50.6281C47.9209 50.7159 47.9028 50.8257 47.9375 50.9183L48.9691 53.6522L47.6531 56.2388C47.6249 56.2937 47.6133 56.3542 47.6188 56.4118L48.239 62.4204C46.9341 57.8904 45.423 52.9414 44.5557 51.1055C43.9302 49.7812 44.7551 46.3491 44.7551 46.3491C44.7551 46.3491 43.4618 47.0507 42.9915 47.5633C41.7774 48.8885 40.4641 50.0204 38.9094 50.9735C36.7744 52.284 34.5626 53.3353 32.1732 54.0455C30.9879 54.3983 30.5314 55.2152 30.4949 56.425C30.4379 58.3181 30.6115 60.1958 30.0474 62.1026C29.6111 63.5794 29.8164 65.2433 29.7154 66.8225C29.5486 69.4275 29.3642 72.0316 29.1875 74.6361H49.991H50.4876H71.292C71.1138 72.0313 70.9294 69.4272 70.7625 66.8225Z"
          fill="white"
        />
      </svg>
    ),
    value: 50,
    suffix: '+',
    title: 'Connected Brokers',
    tooltip: 'Connected Brokers',
  },
];

const quantQuestFeatures = [
  {
    id: 0,
    icon: '/img/strategy-tweak-icon.svg',
    title: 'Design the Competition',
    description: [
      'Institutions and sponsorts can customise the structure, duration, and scope.',
      'Options for campus-exclusive events or nationwide/global reach.',
      "Institutions can integrate real-world financial scenarios and datasets to enhance the competition's relevance.",
      'Tailored themes like algorithmic trading, risk management, or portfolio optimization can be incorporated to align with sponsor goals.',
    ],
  },
  {
    id: 1,
    icon: '/img/strategy-pool.svg',
    title: 'Train and Educate',
    image: '/img/market-access-img.svg',
    description: [
      'Workshops and webinars prepare participants for the competition.',
      'Pre-event training ensures even beginners can excel.',
      'Access to hands-on tools and platforms ensures participants gain practical experience before the event.',
      'Industry experts and mentors provide personalized guidance through live Q&A sessions.',
    ],
  },
  {
    id: 2,
    icon: '/img/testing-icon.svg',
    title: 'Complete and Showcase',
    description: [
      'Participants create and backtest trading strategies to generate the highest ROI.',
      'Winners are recognised with exciting prizes and career opportunities.',
      'Participants present their strategies to a panel of industry veterans for critical feedback and evaluation.',
      'Real-time leaderboards keep the competition engaging and transparent.',
    ],
  },
  {
    id: 3,
    icon: '/img/inclusive-icon.svg',
    title: 'Discover Talent and Build Connections',
    description: [
      'Sponsors and talent hunters can identify top-performing individuals for internships, jobs, or collaborations.',
      'Networking sessions with industry leaders and peers foster long-term professional relationships.',
      "Exclusive access to post-event career fairs and mentorship programs accelerates participants' career growth.",
    ],
  },
];

const pythonFeatureList = [
  {
    id: 0,
    icon: 'coding',
    title: 'Platforms',
    image: '/img/platform-img.svg',
    description:
      "Choose from a versatile array of trading platforms that empower your algorithmic journey. Whether you prefer Phoenix on the web or locally, mobile apps for trading on the go, pyalgotrading for precision, Jupyter notebooks for flexibility, IDE for coding excellence, or command line for command and control, we've got your trading needs covered.",
  },
  {
    id: 1,
    icon: 'flex',
    image: '/img/infra-img.svg',
    title: 'Strategy Development',
    description:
      'Unlock the full spectrum of strategy development possibilities. Code your strategies your way, from 0% to 100% customization. Utilise our ready-made templates for a head start, harness the power of our Phoenix AI Copilot to generate strategies effortlessly in plain english, build your strategies from the ground up, or collaborate with our expert team for tailored solutions.',
  },
  {
    id: 2,
    icon: 'generate',
    image: '/img/strat-exe-img.svg',

    title: 'Strategy Execution',
    description:
      'Execute your strategies on your terms. Choose from Backtesting, Paper Trading, or Live Trading without altering a single line of code. Enhance your optimization strategies by bulk backtesting.',
  },
  {
    id: 3,
    icon: 'upward',
    image: '/img/market-access-img.svg',

    title: 'Market Access',
    description:
      'Dive into the world of trading across Equity, F&O, Commodity, and Currency segments in both Indian and US Markets. Tailor your strategies for global markets and segments with flexibility.',
  },
  {
    id: 4,
    icon: 'shield',
    title: 'Security and Protection',
    image: '/img/protection-img.svg',
    description:
      'Rest easy knowing that your valuable data and strategy codes are safeguarded. You retain complete ownership of your intellectual property.',
  },
  {
    id: 5,
    icon: 'pricing',
    title: 'Analytics and Reporting',
    image: '/img/report-img.svg',

    description:
      "The bedrock of creating winning strategies is thorough analysis. Our comprehensive suite of analytics and reporting features empowers you to dissect your strategy's performance, enabling you to refine and optimise it for the best performance.",
  },
  {
    id: 6,
    icon: 'infra',
    title: 'Infrastructure',
    image: '/img/Infrastructure.svg',

    description:
      "Gain the capability to deploy the entire AlgoBulls Infrastructure locally or on your company's cloud. Enjoy the full spectrum of features and more with our extensive infrastructure support.",
  },
  {
    id: 7,
    icon: 'triangle',
    image: '/img/support-img.svg',
    title: 'Support and Customisation',
    description:
      "Our unwavering commitment to your success means we're here for you at every turn. Whether you require tailor-made strategies, personalised whitelabels with custom branding, custom webhooks, web back offices, or any other form of support, we've got you covered. Your unique needs, our unwavering support.",
  },
];

export const promptCTA = {
  primary: {
    label: 'Get Started NOW !',
    redirect: 'https://app.algobulls.com/user/register',
  },
  secondary: {
    label: 'Request a Demo',
    formType: 'requestDemo',
  },
};

export const pythonBuild = {
  pageTitle:
    'AlgoBulls - Best Algo Trading Platform for Capital Markets Automation',
  pageDescription:
    'AlgoBulls empowers traders with AI-driven algo trading. Develop, test & automate strategies across brokers with ease while ensuring regulatory compliance.',
  hero: {
    titleStart: '',
    highlightedTitle: 'Algo Trading:',
    titleEnd:
      'Effortlessly Create, Optimise & Execute Strategies of any Complexity',
    videoURL:
      'https://www.loom.com/embed/2ff3c038ba6948519e321bbfe970d653?sid=2fc9e4f2-3eac-4738-ad85-4f73e25a92b3',
    description:
      'Is your algo trading idea complex and you want to create your own unique algo trading journey? AlgoBulls allows your trading ideas to run wild and is able to easily accommodate all your requirements with unparalleled algo trading solutions for everyone.',

    images: [
      {
        src: '/img/python-build-hero.png',
        alt: 'AlgoBulls Build Hero',
      },
    ],
    secondary: {
      label: 'Try Phoenix Copilot — Build with AI',
      redirect: 'https://app.algobulls.com/phoenix-copilot',
    },
    primary: {
      label: 'Explore Odyssey Marketplace',
      redirect: 'https://app.algobulls.com/odyssey?category=&displayMode=1',
    },
    text: {
      label: 'Got a question? Reach out to us',
      formType: 'generalQuery',
    },
  },
  problem: {
    title:
      'In Algo Trading, the majority of the time goes into tech and data management, leaving less for winning strategies.',
    // description:
    //   "In the high-stakes game of algorithmic trading, success is elusive for many. Here's the stark reality: over 80% of your time is devoured by the relentless demands of technology and data management. That leaves a mere 20% for what truly counts – executing winning strategies.",
    answer:
      "At AlgoBulls, we understand this pain intimately. It's time to shift the paradigm, where technology works for you, not against you. Let's elevate your trading experience together with AlgoBulls",
    image: '/img/build-problem-main.svg',
    alt: 'problem image',
  },
  solutions: {
    solutionList: [
      {
        title: 'Any Platform',
        description: `Experience flexibility like never before. AlgoBulls adapts to your preferred platform – whether it's a web app, mobile apps, Jupyter notebooks, or CLIs.`,
        icon: '/img/pc.svg',
      },
      {
        title: 'Any Cloud or On-premise',
        icon: '/img/cloud.svg',
        description: `Enjoy the freedom of choice. AlgoBulls Cloud, your cloud, or on-premise – deploy AlgoBulls’ solutions wherever you want, ensuring 100% IP protection at all times. `,
      },
      {
        title: 'Market Versatility',
        description: `Break free from limitations. Algo Trade seamlessly on Equities, F&O, Commodity, Currency across NASDAQ, NYSE, NSE, BSE and more with the broker of your choice.`,
        icon: '/img/market.svg',
      },
      {
        title: 'Generative AI',
        description: `Unleash the power of generative AI. Translate your algo trading ideas into reality with ease by generating strategy codes and parameters through simple prompts in plain English.`,
        icon: '/img/brain.svg',
      },
      {
        title: 'Ready Strategy library',
        description: `Leverage a library of tested and proven strategy codes, saving you time and providing a foundation for successful algo trading strategies.`,
        icon: '/img/book.svg',
      },
    ],
    heading:
      'AlgoBulls - the algo trading platform that is meant for everyone. From beginners to advanced traders and from retail traders to enterprises.',
    subHeading:
      'AlgoBulls is your revolutionary solution that addresses each algo trading pain point with precision.',
  },
  statistics: pythonBuildStats,
  stepTabs: {
    steps: phoenix,
    copilotSteps,
    odysseySteps,
    probuildSteps,
    quantQuestSteps,
    pythonBuildSteps,
  },
};
export const odyssey = {
  pageTitle: 'Odyssey - AlgoBulls | Deploy Whitebox Algos Instantly',
  pageDescription: `Unlock the power of Odyssey by AlgoBulls – a marketplace of expertly designed pre-built Whitebox Execution Algos. Select, test, and deploy strategies effortlessly. No coding required! Trade smarter with AI-driven automation today.`,
  hero: {
    displayTitle: 'Odyssey',
    videoURL:
      'https://www.loom.com/embed/be72afb03b9c404ab5d6576afbef60ec?sid=4b5a95ee-0d43-437d-aae5-289da8404064',
    title:
      'Discover, Select, and get Desired Execution in Your Trading Journey',
    description: `A marketplace filled with meticulously crafted trading strategies, designed by experts and optimised for different market conditions. That's "Odyssey" by AlgoBulls—a powerful platform where traders of all levels can find, evaluate, and activate pre-created algotrading strategies in just a few clicks.`,
    primary: {
      label: 'Start Trading with your 30 Days FREE Trial Now!',
      redirect: 'https://app.algobulls.com/user/register',
    },
    secondary: {
      label: 'Explore Our Marketplace',
      redirect:
        'https://app.algobulls.com/odyssey?category=&displayMode=0&query=eyJpc0xpdmUiOiJ0cnVlIiwiY3VycmVudFBhZ2UiOjEsInBhZ2VTaXplIjo2fQ%3D%3D',
    },
  },
  solutions: [
    {
      title: 'Curated Strategies for Every Need',
      description: `Whether you're a beginner looking for reliable algorithms or an experienced trader seeking to amplify your trading activities, Odyssey has a strategy that fits your needs. Browse through our extensive collection and choose based on segment, instrument, market condition, or your preferred trading style.`,
      icon: '/img/pc.svg',
    },
    {
      title: 'Comprehensive Details for Confident Decisions',
      icon: '/img/cloud.svg',
      description: `Odyssey puts transparency at the forefront. Get full access to strategy descriptions in terms of the type of strategy, its logic & conditions, the parameters used and other segment-specific details. With this in-depth knowledge at your fingertips, you can trade with greater confidence and precision.`,
    },
    {
      title: 'A Marketplace that Adapts to You',
      description: `Our easy-to-navigate platform empowers you to filter strategies using tags that matter to you-whether it's your trading experience, the type of instrument, the segment of your choice, or any other filter you want to use. Odyssey's personalised search capabilities ensure you quickly find strategies that align with your trading objectives.`,
      icon: '/img/market.svg',
    },
    {
      title: 'Seamless Integration for Instant Activation',
      description: `Ready to deploy a strategy? With Odyssey, it's a breeze. Activate the strategy of your choice directly on your preferred broker platform by adding it to My Portfolio-fully automated and ready to go. Spend less time on setup and more time on what matters-growing your algotrading game.`,
      icon: '/img/brain.svg',
    },
  ],
  tradingStep: [
    {
      step: '01',
      title: 'Beginner Traders',
      description:
        'Simplify your journey into algorithmic trading with beginner-friendly strategies that are easy to understand and implement.',
    },
    {
      step: '02',
      title: 'Experienced Traders',
      description:
        'Find advanced strategies that match your specific criteria, optimise your portfolio, and enhance growth.',
    },
    {
      step: '03',
      title: 'Passive Income Seekers',
      description:
        'Let your money work for you. Choose an automated strategy, sit back, and let the algorithm trade on your behalf.',
    },
  ],
};
export const pricing = {
  pageTitle:
    'Unlock the Power of AlgoBulls with Plans Designed for Every Trader',
  pageDescription:
    "Discover the perfect plan for your trading journey with AlgoBulls. Whether you're a retail trader or part of a large institution, our flexible pricing options ensure you have the tools and resources you need to succeed. Explore our plans for Phoenix and Odyssey along with support plans, and choose the one that aligns with your goals and budget.",
  hero: {
    title: 'Unlock the Power of AlgoBulls with Plans Designed for Every Trader',
    description:
      "Discover the perfect plan for your trading journey with AlgoBulls. Whether you're a retail trader or part of a large institution, our flexible pricing options ensure you have the tools and resources you need to succeed. Explore our plans for Phoenix and Odyssey along with support plans, and choose the one that aligns with your goals and budget.",
  },
};

export const b2b = {
  pageTitle: 'Gen AI powered Hedge Fund in a Box',
  pageDescription:
    'One solution to all your enterprise algorithmic trading problems. We make data and technology management seamless',
  hero: {
    displayTitle: 'Enterprise',
    title: 'Gen AI powered Hedge Fund in a Box',
    slideImages: [
      {
        src: '/img/Phoenix Analytics.png',
        alt: 'Phoenix Analytics',
      },
      {
        src: '/img/Odyssey List View.png',
        alt: 'Odyssey List View',
      },
      {
        src: '/img/Phoenix Analytics.png',
        alt: 'Phoenix Analytics',
      },
      {
        src: '/img/Odyssey Strategy Details.png',
        alt: 'Odyssey Strategy Details',
      },
    ],
    description:
      'One solution to all your enterprise algorithmic trading problems. We make data and technology management seamless',
    miniCards: [
      {
        name: 'Any Platform, Any Cloud',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none">
            <path
              d="M33.6136 12.9925H31.4318V11.9016C31.4318 11.0337 31.087 10.2012 30.4732 9.58747C29.8595 8.97371 29.0271 8.62891 28.1591 8.62891H8.52272C7.65474 8.62891 6.82231 8.97371 6.20856 9.58747C5.5948 10.2012 5.25 11.0337 5.25 11.9016V24.9925C5.25 25.8605 5.5948 26.693 6.20856 27.3067C6.82231 27.9205 7.65474 28.2653 8.52272 28.2653H23.7954V29.3562C23.7954 30.2242 24.1402 31.0566 24.754 31.6703C25.3678 32.2841 26.2002 32.6289 27.0682 32.6289H33.6136C34.4816 32.6289 35.314 32.2841 35.9278 31.6703C36.5415 31.0566 36.8863 30.2242 36.8863 29.3562V16.2653C36.8863 15.3973 36.5415 14.5649 35.9278 13.9511C35.314 13.3373 34.4816 12.9925 33.6136 12.9925ZM8.52272 26.0835C8.2334 26.0835 7.95592 25.9685 7.75134 25.7639C7.54675 25.5593 7.43182 25.2819 7.43182 24.9925V11.9016C7.43182 11.6123 7.54675 11.3348 7.75134 11.1302C7.95592 10.9257 8.2334 10.8107 8.52272 10.8107H28.1591C28.4484 10.8107 28.7259 10.9257 28.9305 11.1302C29.135 11.3348 29.25 11.6123 29.25 11.9016V12.9925H27.0682C26.2002 12.9925 25.3678 13.3373 24.754 13.9511C24.1402 14.5649 23.7954 15.3973 23.7954 16.2653V26.0835H8.52272ZM34.7045 29.3562C34.7045 29.6455 34.5896 29.923 34.385 30.1276C34.1804 30.3322 33.9029 30.4471 33.6136 30.4471H27.0682C26.7788 30.4471 26.5014 30.3322 26.2968 30.1276C26.0922 29.923 25.9773 29.6455 25.9773 29.3562V16.2653C25.9773 15.9759 26.0922 15.6985 26.2968 15.4939C26.5014 15.2893 26.7788 15.1744 27.0682 15.1744H33.6136C33.9029 15.1744 34.1804 15.2893 34.385 15.4939C34.5896 15.6985 34.7045 15.9759 34.7045 16.2653V29.3562ZM21.6136 31.538C21.6136 31.8273 21.4987 32.1048 21.2941 32.3094C21.0895 32.514 20.812 32.6289 20.5227 32.6289H15.0682C14.7788 32.6289 14.5014 32.514 14.2968 32.3094C14.0922 32.1048 13.9773 31.8273 13.9773 31.538C13.9773 31.2487 14.0922 30.9712 14.2968 30.7666C14.5014 30.562 14.7788 30.4471 15.0682 30.4471H20.5227C20.812 30.4471 21.0895 30.562 21.2941 30.7666C21.4987 30.9712 21.6136 31.2487 21.6136 31.538ZM32.5227 18.4471C32.5227 18.7364 32.4078 19.0139 32.2032 19.2185C31.9986 19.4231 31.7211 19.538 31.4318 19.538H29.25C28.9607 19.538 28.6832 19.4231 28.4786 19.2185C28.274 19.0139 28.1591 18.7364 28.1591 18.4471C28.1591 18.1578 28.274 17.8803 28.4786 17.6757C28.6832 17.4711 28.9607 17.3562 29.25 17.3562H31.4318C31.7211 17.3562 31.9986 17.4711 32.2032 17.6757C32.4078 17.8803 32.5227 18.1578 32.5227 18.4471Z"
              fill="#2C78F6"
            />
          </svg>
        ),
      },
      {
        name: 'Any Market, Any Broker',
        icon: (
          <svg
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24.9405 10.8086C23.0478 10.81 21.1928 11.338 19.583 12.3334C17.9733 13.3288 16.6721 14.7524 15.8252 16.445C14.8176 16.2981 13.7905 16.3603 12.808 16.6278C11.8256 16.8954 10.9088 17.3625 10.1148 18.0001C9.32089 18.6376 8.66682 19.4319 8.19343 20.3334C7.72005 21.2349 7.43749 22.2243 7.3634 23.2399C7.28931 24.2554 7.42526 25.2753 7.76278 26.236C8.1003 27.1967 8.63215 28.0775 9.32515 28.8235C10.0182 29.5696 10.8574 30.1648 11.7907 30.5721C12.7239 30.9794 13.731 31.1901 14.7493 31.1909H24.9405C27.6433 31.1909 30.2355 30.1172 32.1467 28.206C34.0579 26.2948 35.1316 23.7026 35.1316 20.9998C35.1316 18.2969 34.0579 15.7047 32.1467 13.7935C30.2355 11.8823 27.6433 10.8086 24.9405 10.8086ZM24.9405 29.338H14.7493C13.275 29.338 11.8611 28.7523 10.8186 27.7099C9.77613 26.6674 9.19047 25.2535 9.19047 23.7792C9.19047 22.3049 9.77613 20.891 10.8186 19.8485C11.8611 18.806 13.275 18.2204 14.7493 18.2204C14.8767 18.2204 15.0041 18.2204 15.1303 18.2331C14.8769 19.1335 14.7487 20.0644 14.7493 20.9998C14.7493 21.2455 14.8469 21.4811 15.0206 21.6549C15.1944 21.8286 15.43 21.9262 15.6758 21.9262C15.9215 21.9262 16.1571 21.8286 16.3309 21.6549C16.5046 21.4811 16.6022 21.2455 16.6022 20.9998C16.6022 19.3506 17.0913 17.7385 18.0075 16.3673C18.9237 14.9961 20.2259 13.9273 21.7496 13.2962C23.2732 12.6651 24.9497 12.5 26.5672 12.8218C28.1846 13.1435 29.6704 13.9376 30.8365 15.1037C32.0026 16.2699 32.7968 17.7556 33.1185 19.3731C33.4402 20.9905 33.2751 22.6671 32.644 24.1907C32.0129 25.7143 30.9442 27.0165 29.5729 27.9328C28.2017 28.849 26.5896 29.338 24.9405 29.338ZM29.3018 18.4914C29.388 18.5774 29.4563 18.6796 29.5029 18.792C29.5496 18.9045 29.5735 19.0251 29.5735 19.1468C29.5735 19.2686 29.5496 19.3891 29.5029 19.5016C29.4563 19.6141 29.388 19.7163 29.3018 19.8023L23.743 25.3611C23.657 25.4473 23.5548 25.5156 23.4423 25.5622C23.3298 25.6089 23.2093 25.6329 23.0875 25.6329C22.9658 25.6329 22.8452 25.6089 22.7327 25.5622C22.6203 25.5156 22.5181 25.4473 22.432 25.3611L19.6526 22.5817C19.4788 22.4079 19.3811 22.1721 19.3811 21.9262C19.3811 21.6804 19.4788 21.4446 19.6526 21.2708C19.8265 21.0969 20.0623 20.9993 20.3081 20.9993C20.554 20.9993 20.7897 21.0969 20.9636 21.2708L23.0875 23.3959L27.9909 18.4914C28.0769 18.4052 28.1791 18.3369 28.2916 18.2903C28.404 18.2436 28.5246 18.2196 28.6464 18.2196C28.7681 18.2196 28.8887 18.2436 29.0011 18.2903C29.1136 18.3369 29.2158 18.4052 29.3018 18.4914Z"
              fill="#2C78F6"
            />
          </svg>
        ),
      },
      {
        name: 'Trusted & Maintained Code',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none">
            <path
              d="M32.7422 8.99805H24.7422C23.966 8.99805 23.2004 9.17877 22.5061 9.52591C21.8118 9.87305 21.2079 10.3771 20.7422 10.998C20.2765 10.3771 19.6725 9.87305 18.9783 9.52591C18.284 9.17877 17.5184 8.99805 16.7422 8.99805H8.74219C8.21175 8.99805 7.70305 9.20876 7.32797 9.58383C6.9529 9.95891 6.74219 10.4676 6.74219 10.998V26.998C6.74219 27.5285 6.9529 28.0372 7.32797 28.4123C7.70305 28.7873 8.21175 28.998 8.74219 28.998H16.7422C17.5378 28.998 18.3009 29.3141 18.8635 29.8767C19.4261 30.4393 19.7422 31.2024 19.7422 31.998C19.7422 32.2633 19.8475 32.5176 20.0351 32.7052C20.2226 32.8927 20.477 32.998 20.7422 32.998C21.0074 32.998 21.2618 32.8927 21.4493 32.7052C21.6368 32.5176 21.7422 32.2633 21.7422 31.998C21.7422 31.2024 22.0583 30.4393 22.6209 29.8767C23.1835 29.3141 23.9465 28.998 24.7422 28.998H32.7422C33.2726 28.998 33.7813 28.7873 34.1564 28.4123C34.5315 28.0372 34.7422 27.5285 34.7422 26.998V10.998C34.7422 10.4676 34.5315 9.95891 34.1564 9.58383C33.7813 9.20876 33.2726 8.99805 32.7422 8.99805ZM16.7422 26.998H8.74219V10.998H16.7422C17.5378 10.998 18.3009 11.3141 18.8635 11.8767C19.4261 12.4393 19.7422 13.2024 19.7422 13.998V27.998C18.8775 27.3474 17.8243 26.9963 16.7422 26.998ZM32.7422 26.998H24.7422C23.6601 26.9963 22.6069 27.3474 21.7422 27.998V13.998C21.7422 13.2024 22.0583 12.4393 22.6209 11.8767C23.1835 11.3141 23.9465 10.998 24.7422 10.998H32.7422V26.998ZM24.7422 13.998H29.7422C30.0074 13.998 30.2618 14.1034 30.4493 14.2909C30.6368 14.4785 30.7422 14.7328 30.7422 14.998C30.7422 15.2633 30.6368 15.5176 30.4493 15.7052C30.2618 15.8927 30.0074 15.998 29.7422 15.998H24.7422C24.477 15.998 24.2226 15.8927 24.0351 15.7052C23.8475 15.5176 23.7422 15.2633 23.7422 14.998C23.7422 14.7328 23.8475 14.4785 24.0351 14.2909C24.2226 14.1034 24.477 13.998 24.7422 13.998ZM30.7422 18.998C30.7422 19.2633 30.6368 19.5176 30.4493 19.7052C30.2618 19.8927 30.0074 19.998 29.7422 19.998H24.7422C24.477 19.998 24.2226 19.8927 24.0351 19.7052C23.8475 19.5176 23.7422 19.2633 23.7422 18.998C23.7422 18.7328 23.8475 18.4785 24.0351 18.2909C24.2226 18.1034 24.477 17.998 24.7422 17.998H29.7422C30.0074 17.998 30.2618 18.1034 30.4493 18.2909C30.6368 18.4785 30.7422 18.7328 30.7422 18.998ZM30.7422 22.998C30.7422 23.2633 30.6368 23.5176 30.4493 23.7052C30.2618 23.8927 30.0074 23.998 29.7422 23.998H24.7422C24.477 23.998 24.2226 23.8927 24.0351 23.7052C23.8475 23.5176 23.7422 23.2633 23.7422 22.998C23.7422 22.7328 23.8475 22.4785 24.0351 22.2909C24.2226 22.1034 24.477 21.998 24.7422 21.998H29.7422C30.0074 21.998 30.2618 22.1034 30.4493 22.2909C30.6368 22.4785 30.7422 22.7328 30.7422 22.998Z"
              fill="#2C78F6"
            />
          </svg>
        ),
      },
      {
        name: 'Backoffice Analytics',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none">
            <path
              d="M27.8148 11.2946C27.8153 11.2084 27.8036 11.1227 27.7801 11.0398L26.1182 5.22619C26.0065 4.84045 25.773 4.50119 25.4526 4.25907C25.1322 4.01695 24.7421 3.88496 24.3405 3.88281H7.20083C6.79924 3.88496 6.40913 4.01695 6.08873 4.25907C5.76834 4.50119 5.53486 4.84045 5.42316 5.22619L3.76246 11.0398C3.73854 11.1226 3.72645 11.2084 3.72656 11.2946V13.1475C3.72656 13.8667 3.894 14.5759 4.21561 15.2192C4.53723 15.8624 5.00418 16.4219 5.5795 16.8534V24.2652C5.5795 24.7566 5.77472 25.2279 6.12222 25.5754C6.46971 25.9229 6.94102 26.1181 7.43245 26.1181H24.1089C24.6003 26.1181 25.0716 25.9229 25.4191 25.5754C25.7666 25.2279 25.9619 24.7566 25.9619 24.2652V16.8534C26.5372 16.4219 27.0041 15.8624 27.3257 15.2192C27.6474 14.5759 27.8148 13.8667 27.8148 13.1475V11.2946ZM7.20083 5.73575H24.3405L25.6631 10.3681H5.88177L7.20083 5.73575ZM12.9913 12.221H18.5501V13.1475C18.5501 13.8847 18.2573 14.5916 17.736 15.1129C17.2148 15.6341 16.5078 15.9269 15.7707 15.9269C15.0335 15.9269 14.3266 15.6341 13.8053 15.1129C13.2841 14.5916 12.9913 13.8847 12.9913 13.1475V12.221ZM11.1383 12.221V13.1475C11.1383 13.8847 10.8455 14.5916 10.3243 15.1129C9.80302 15.6341 9.09606 15.9269 8.35892 15.9269C7.62177 15.9269 6.91482 15.6341 6.39358 15.1129C5.87233 14.5916 5.5795 13.8847 5.5795 13.1475V12.221H11.1383ZM24.1089 24.2652H7.43245V17.6872C7.73744 17.7487 8.04779 17.7797 8.35892 17.7799C9.07807 17.7799 9.78734 17.6124 10.4306 17.2908C11.0738 16.9692 11.6333 16.5022 12.0648 15.9269C12.4963 16.5022 13.0558 16.9692 13.699 17.2908C14.3423 17.6124 15.0515 17.7799 15.7707 17.7799C16.4898 17.7799 17.1991 17.6124 17.8423 17.2908C18.4856 16.9692 19.0451 16.5022 19.4766 15.9269C19.9081 16.5022 20.4676 16.9692 21.1108 17.2908C21.754 17.6124 22.4633 17.7799 23.1824 17.7799C23.4936 17.7797 23.8039 17.7487 24.1089 17.6872V24.2652ZM23.1824 15.9269C22.4453 15.9269 21.7383 15.6341 21.2171 15.1129C20.6959 14.5916 20.403 13.8847 20.403 13.1475V12.221H25.9619V13.1475C25.9619 13.8847 25.669 14.5916 25.1478 15.1129C24.6265 15.6341 23.9196 15.9269 23.1824 15.9269Z"
              fill="#2C78F6"
            />
          </svg>
        ),
      },
      {
        name: 'Generative AI',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none">
            <path
              d="M38.1024 20.743C38.101 19.2594 37.6794 17.8065 36.8865 16.5525C36.0937 15.2985 34.9619 14.2946 33.6223 13.6571V13.4625C33.621 12.0193 33.1551 10.6149 32.2937 9.45699C31.4323 8.2991 30.221 7.44929 28.8391 7.03329C27.4572 6.61729 25.9781 6.65721 24.6206 7.14714C23.2632 7.63707 22.0995 8.55098 21.3017 9.75365C20.504 8.55098 19.3403 7.63707 17.9829 7.14714C16.6254 6.65721 15.1463 6.61729 13.7644 7.03329C12.3825 7.44929 11.1712 8.2991 10.3098 9.45699C9.44836 10.6149 8.98253 12.0193 8.98124 13.4625V13.6571C7.64045 14.2929 6.50761 15.2961 5.71435 16.5502C4.9211 17.8043 4.5 19.2577 4.5 20.7416C4.5 22.2256 4.9211 23.679 5.71435 24.9331C6.50761 26.1872 7.64045 27.1904 8.98124 27.8262V28.0236C8.98253 29.4668 9.44836 30.8712 10.3098 32.0291C11.1712 33.187 12.3825 34.0368 13.7644 34.4528C15.1463 34.8688 16.6254 34.8289 17.9829 34.3389C19.3403 33.849 20.504 32.9351 21.3017 31.7324C22.0995 32.9351 23.2632 33.849 24.6206 34.3389C25.9781 34.8289 27.4572 34.8688 28.8391 34.4528C30.221 34.0368 31.4323 33.187 32.2937 32.0291C33.1551 30.8712 33.621 29.4668 33.6223 28.0236V27.8262C34.9617 27.1891 36.0933 26.1858 36.8862 24.9323C37.6791 23.6787 38.1008 22.2263 38.1024 20.743ZM15.7015 32.5039C14.5968 32.5037 13.5311 32.0954 12.7091 31.3574C11.887 30.6193 11.3667 29.6036 11.2479 28.5052C11.6101 28.5569 11.9755 28.5831 12.3414 28.5836H13.4614C13.7585 28.5836 14.0434 28.4656 14.2534 28.2555C14.4635 28.0455 14.5815 27.7606 14.5815 27.4635C14.5815 27.1665 14.4635 26.8816 14.2534 26.6715C14.0434 26.4615 13.7585 26.3435 13.4614 26.3435H12.3414C11.0191 26.345 9.73893 25.8786 8.72751 25.0269C7.7161 24.1751 7.03867 22.9929 6.81518 21.6896C6.59168 20.3864 6.83653 19.046 7.50638 17.9059C8.17623 16.7659 9.22786 15.8996 10.4751 15.4605C10.6933 15.3832 10.8823 15.2402 11.0159 15.0512C11.1495 14.8621 11.2213 14.6363 11.2213 14.4048V13.4625C11.2213 12.2743 11.6933 11.1347 12.5335 10.2944C13.3737 9.45423 14.5133 8.98219 15.7015 8.98219C16.8897 8.98219 18.0293 9.45423 18.8695 10.2944C19.7097 11.1347 20.1817 12.2743 20.1817 13.4625V23.0196C18.9518 21.9134 17.3557 21.3019 15.7015 21.3031C15.4045 21.3031 15.1196 21.4211 14.9095 21.6311C14.6995 21.8412 14.5815 22.1261 14.5815 22.4232C14.5815 22.7202 14.6995 23.0051 14.9095 23.2152C15.1196 23.4252 15.4045 23.5432 15.7015 23.5432C16.8897 23.5432 18.0293 24.0153 18.8695 24.8555C19.7097 25.6957 20.1817 26.8353 20.1817 28.0236C20.1817 29.2118 19.7097 30.3514 18.8695 31.1916C18.0293 32.0319 16.8897 32.5039 15.7015 32.5039ZM30.2621 26.3435H29.1421C28.845 26.3435 28.5601 26.4615 28.3501 26.6715C28.14 26.8816 28.022 27.1665 28.022 27.4635C28.022 27.7606 28.14 28.0455 28.3501 28.2555C28.5601 28.4656 28.845 28.5836 29.1421 28.5836H30.2621C30.628 28.5831 30.9934 28.5569 31.3556 28.5052C31.2625 29.3658 30.9222 30.181 30.3757 30.8523C29.8292 31.5236 29.0999 32.0221 28.2761 32.2878C27.4523 32.5534 26.5691 32.5746 25.7335 32.349C24.8978 32.1234 24.1454 31.6605 23.5672 31.0163C22.989 30.3721 22.6098 29.5742 22.4755 28.7191C22.3411 27.864 22.4573 26.9882 22.81 26.1978C23.1628 25.4073 23.737 24.7359 24.4631 24.2648C25.1893 23.7938 26.0364 23.5431 26.902 23.5432C27.199 23.5432 27.4839 23.4252 27.694 23.2152C27.904 23.0051 28.022 22.7202 28.022 22.4232C28.022 22.1261 27.904 21.8412 27.694 21.6311C27.4839 21.4211 27.199 21.3031 26.902 21.3031C25.2478 21.3019 23.6517 21.9134 22.4218 23.0196V13.4625C22.4218 12.2743 22.8938 11.1347 23.734 10.2944C24.5742 9.45423 25.7138 8.98219 26.902 8.98219C28.0902 8.98219 29.2297 9.45423 30.0699 10.2944C30.9101 11.1347 31.3822 12.2743 31.3822 13.4625V14.4048C31.3822 14.6363 31.454 14.8621 31.5876 15.0512C31.7212 15.2402 31.9102 15.3832 32.1284 15.4605C33.3756 15.8996 34.4273 16.7659 35.0971 17.9059C35.767 19.046 36.0118 20.3864 35.7883 21.6896C35.5648 22.9929 34.8874 24.1751 33.876 25.0269C32.8646 25.8786 31.5844 26.345 30.2621 26.3435ZM32.5022 19.0629C32.5022 19.36 32.3842 19.6449 32.1742 19.8549C31.9641 20.065 31.6792 20.183 31.3822 20.183H30.8221C29.4854 20.183 28.2034 19.652 27.2582 18.7067C26.313 17.7615 25.7819 16.4794 25.7819 15.1426V14.5826C25.7819 14.2855 25.8999 14.0006 26.11 13.7906C26.32 13.5805 26.6049 13.4625 26.902 13.4625C27.199 13.4625 27.4839 13.5805 27.694 13.7906C27.904 14.0006 28.022 14.2855 28.022 14.5826V15.1426C28.022 15.8853 28.317 16.5975 28.8422 17.1227C29.3673 17.6478 30.0795 17.9428 30.8221 17.9428H31.3822C31.6792 17.9428 31.9641 18.0609 32.1742 18.2709C32.3842 18.481 32.5022 18.7659 32.5022 19.0629ZM11.7814 20.183H11.2213C10.9243 20.183 10.6394 20.065 10.4293 19.8549C10.2193 19.6449 10.1013 19.36 10.1013 19.0629C10.1013 18.7659 10.2193 18.481 10.4293 18.2709C10.6394 18.0609 10.9243 17.9428 11.2213 17.9428H11.7814C12.524 17.9428 13.2362 17.6478 13.7613 17.1227C14.2865 16.5975 14.5815 15.8853 14.5815 15.1426V14.5826C14.5815 14.2855 14.6995 14.0006 14.9095 13.7906C15.1196 13.5805 15.4045 13.4625 15.7015 13.4625C15.9986 13.4625 16.2835 13.5805 16.4935 13.7906C16.7036 14.0006 16.8216 14.2855 16.8216 14.5826V15.1426C16.8216 16.4794 16.2905 17.7615 15.3453 18.7067C14.4001 19.652 13.1181 20.183 11.7814 20.183Z"
              fill="#2C78F6"
            />
          </svg>
        ),
      },
    ],
    images: [
      {
        src: '/img/b2b-hero-slide-1.png',
        alt: 'b2b-slide-1',
      },
      {
        src: '/img/b2b-hero-slide-2.png',
        alt: 'b2b-slide-2',
      },
      {
        src: '/img/b2b-hero-slide-3.png',
        alt: 'b2b-slide-3',
      },
    ],
    primary: {
      label: 'Contact Sales',
      formType: 'requestQuote',
    },
    secondary: {
      label: 'Explore Our Platform',
      redirect: 'https://app.algobulls.com/odyssey',
    },
  },
  problem: {
    title:
      'In Algo Trading, the majority of the time goes into tech and data management, leaving less for winning strategies.',
    description:
      'Enterprises struggle with the complexity of managing and scaling their infrastructure.',
    answer:
      "At AlgoBulls, we understand this pain intimately. It's time to shift the paradigm, where technology works for you, not against you. Let's elevate your trading experience together with AlgoBulls",
    image: '/img/b2b-problem-image.svg',
    imageAlt: 'b2b problem image',
  },
  statistics: pythonBuildStats,
  features: pythonFeatureList,
};

export const probuild = {
  pageTitle:
    'Pro Build - AlgoBulls | Expert Algorithm Development and Integration',
  pageDescription:
    'Turn your trading vision into reality with Phoenix Pro Build by AlgoBulls. Our expert strategy creators help you customise and develop high-performance trading algorithms tailored to your needs.',
  hero: {
    displayTitle: 'Phoenix Pro Build',
    title: 'Custom Algorithms. Expert Development. Seamless Integration',
    slideImages: [
      {
        src: '/img/Phoenix Analytics.png',
        alt: 'Phoenix Analytics',
      },
      {
        src: '/img/Odyssey List View.png',
        alt: 'Odyssey List View',
      },
      {
        src: '/img/Phoenix Analytics.png',
        alt: 'Phoenix Analytics',
      },
      {
        src: '/img/Odyssey Strategy Details.png',
        alt: 'Odyssey Strategy Details',
      },
    ],
    description:
      'Whether you’re an individual trader or a professional firm, our expert team turns your strategy into a powerful algorithm',
    images: [
      {
        src: '/img/b2b-hero-slide-1.png',
        alt: 'b2b-slide-1',
      },
      {
        src: '/img/b2b-hero-slide-2.png',
        alt: 'b2b-slide-2',
      },
      {
        src: '/img/b2b-hero-slide-3.png',
        alt: 'b2b-slide-3',
      },
    ],
    primary: {
      label: 'Share Your Strategy to Get a FREE Consultation',
      redirect:
        'https://docs.google.com/spreadsheets/d/1PhvIVZfKJJMb16hix_pl81-57_rWGSbUVTrwABxd4Pc/edit?gid=0#gid=0',
    },
  },
  problems: [
    {
      step: '01',
      title: 'As Independent Traders (B2C)',
      img: '/img/free_trader.svg',
      description:
        'You have a trading strategy that shows promise, but translating it into a fully automated algorithm requires technical expertise, time, and the right tools. Without automation, you risk missing out on potential opportunities and efficiency gains.',
    },
    {
      step: '02',
      title: 'As Professional Firms & Institutions (B2B)',
      img: '/img/professional_trader.svg',
      description:
        'Your trading desk needs a scalable, efficient way to automate complex strategies and capitalise on market opportunities. However, developing a custom algorithm that integrates seamlessly with your systems and meets your performance criteria can be a daunting and resource-intensive task.',
    },
  ],
  solutions: {
    solutionList: [
      {
        title: 'Expert Development for Every Strategy Type',
        description:
          'Phoenix Pro Build is designed for traders of all levels. Whether you have an Equity, Options, screener-based, or multi-indicator strategy—or even if you use platforms like TradingView or Chartink for your signals—our team has the expertise to turn your concept into a fully functional algorithm.',
        icon: '/img/brain.svg',
      },
      {
        title: 'Tailored to Your Needs',
        icon: '/img/upward.svg',
        description:
          'We work closely with you to understand your trading approach and tailor the algorithm to meet your specific goals, ensuring the solution is perfectly aligned with your trading style.',
      },
      {
        title: 'Efficiency, Precision, and Scalability',
        description: `From backtesting and optimisation to deployment, we ensure that your algorithm not only performs with precision but also scales as your needs grow—whether you’re an individual trader scaling up or a firm handling multiple strategies.`,
        icon: '/img/target.svg',
      },
      {
        title: 'Seamless Integration & Execution',
        description:
          'Our algorithms are built to integrate effortlessly with your existing trading systems and preferred charting platforms, providing you with a streamlined, end-to-end solution that enhances your trading efficiency.',
        icon: '/img/pc.svg',
      },
    ],
  },
  // statistics: pythonBuildStats,
  features: probuildFeatureList,
};

export const pythonBuildPage = {
  pageTitle: 'Python Build - AlgoBulls | Python Algo Trading Platform',
  pageDescription:
    'Discover Phoenix Python Build by AlgoBulls, a powerful Python algo trading platform enabling seamless strategy creation, testing, and execution.',
  hero: {
    displayTitle: 'Phoenix Python Build',
    title: 'Code. Customise. Conquer.',
    slideImages: [
      {
        src: '/img/Phoenix Analytics.png',
        alt: 'Phoenix Analytics',
      },
      {
        src: '/img/Odyssey List View.png',
        alt: 'Odyssey List View',
      },
      {
        src: '/img/Phoenix Analytics.png',
        alt: 'Phoenix Analytics',
      },
      {
        src: '/img/Odyssey Strategy Details.png',
        alt: 'Odyssey Strategy Details',
      },
    ],
    description:
      'Build Powerful Trading Strategies using Python with Phoenix Python Build. Unleash your trading potential with a state-of-the-art Python-based algorithmic strategy builder.',
    images: [
      {
        src: '/img/b2b-hero-slide-1.png',
        alt: 'b2b-slide-1',
      },
      {
        src: '/img/b2b-hero-slide-2.png',
        alt: 'b2b-slide-2',
      },
      {
        src: '/img/b2b-hero-slide-3.png',
        alt: 'b2b-slide-3',
      },
    ],
    primary: {
      label: 'Start Building Now',
      redirect: 'https://app.algobulls.com/phoenix/splash',
    },
    secondary: {
      label: 'Expore Templates',
      redirect:
        'https://app.algobulls.com/phoenix/MyAllStrategy?query=eyJTdHJhdGVneVR5cGUiOiJSZWFkeVRlbXBsYXRlIiwiY3VycmVudFBhZ2UiOjEsInBhZ2VTaXplIjo4fQ%3D%3D',
    },
  },
  problems: [
    {
      step: '01',
      title: 'For Developers & Quants',
      img: '/img/free_trader.svg',
      description:
        'Build powerful trading algorithms using Python, Jupyter Notebooks, and CLI execution.',
    },
    {
      step: '02',
      title: 'For Professional Traders',
      img: '/img/professional_trader.svg',
      description:
        'Customise and refine strategies with seamless backtesting and analytics.',
    },
    {
      step: '03',
      title: 'For Researchers & Analysts ',
      img: '/img/market-access-img.svg',
      description:
        'Experiment with different models, integrate machine learning, and test trading hypotheses.',
    },
  ],
  solutions: {
    solutionList: [
      {
        title: 'ML & Data Science Library Integration',
        description:
          'Leverage powerful libraries like TensorFlow, Keras, PyTorch, scikit-learn, numpy, pandas, scipy, and more to build, train, and deploy ML models within your strategies.',
        icon: '/img/brain.svg',
      },
      {
        title: 'Predictive Analytics',
        description:
          'Use historical and real-time data to predict price movements, volatility, and trend reversals with enhanced accuracy.',
        icon: '/img/pc.svg',
      },
      {
        title: 'Custom Model Support',
        icon: '/img/upward.svg',
        description:
          'Import and deploy your own pre-trained models directly within your strategy code for tailored trading intelligence.',
      },
      {
        title: 'Backtesting ML Models',
        icon: '/img/cloud.svg',
        description:
          'Test your machine learning strategies on historical data to validate accuracy, precision, and profitability before live deployment',
      },
      {
        title: 'Automated Execution',
        icon: '/img/book.svg',
        description:
          'Seamlessly deploy ML-powered strategies on the AlgoBulls platform with real-time automation and infrastructure support—no server setup needed.',
      },
      {
        title: 'Flexible Setup',
        icon: '/img/target.svg',
        description:
          'Get access to entire setup on a single server for super-fast execution or on a web-based platform for ease of deployment.',
      },
    ],
  },
  bottomCTA: {
    title: 'Ready to Code & Conquer the Markets?',
    subtitle:
      'Build, test, and deploy trading strategies with Phoenix Python Build',
    description:
      'Take your algorithmic trading skills to the next level with Phoenix Python Build. Seamlessly develop, backtest, and execute trading strategies in a robust and intuitive environment designed for traders of all levels. Start coding, optimise performance, and gain a competitive edge in the financial markets today.',
    buttons: [
      {
        title: 'Start Building Now ',
        url: 'https://app.algobulls.com/phoenix/splash',
      },
      {
        title: 'Explore Templates',
        url: 'https://app.algobulls.com/phoenix/MyAllStrategy?query=eyJTdHJhdGVneVR5cGUiOiJSZWFkeVRlbXBsYXRlIiwiY3VycmVudFBhZ2UiOjEsInBhZ2VTaXplIjo4fQ%3D%3D',
      },
    ],
  },
  // statistics: pythonBuildStats,
  features: pythonBuildPageFeatureList,
};

export const b2c = {
  pageTitle: 'Phoenix - AlgoBulls | Automate Trading Strategies with Python',
  pageDescription:
    'Take control of your trading with Phoenix by AlgoBulls – a powerful Python-based platform to code, test, and automate algorithmic trading strategies. Use Jupyter Notebooks, integrate popular libraries, and deploy seamlessly. Start building today!',
  hero: {
    displayTitle: 'Phoenix',
    title: 'Your Strategy, Your Code, Your Customisations',
    description: `Have complete control over your strategy with an unparalleled coding environment. Unlock the power of algo trading with Phoenix - where complex technology meets simple & user-friendly Interface.`,
    videoURL:
      'https://www.loom.com/embed/6a2b21590c9943208020ea4141408bd9?sid=07f9fd0d-b2d3-4c64-a96d-7fb2d3d54cf8',
    images: [
      {
        src: '/img/b2c-hero.png',
        alt: 'b2b-slide-1',
      },
    ],
    primary: {
      label: 'Get Started. It’s FREE for the first 30 Days',
      redirect:
        'https://app.algobulls.com/pricing?duration=0&section=Developers',
    },
    secondary: {
      label: 'Explore Ready Templates',
      redirect:
        'https://app.algobulls.com/phoenix/MyAllStrategy?query=eyJTdHJhdGVneVR5cGUiOiJSZWFkeVRlbXBsYXRlIiwiY3VycmVudFBhZ2UiOjEsInBhZ2VTaXplIjo4fQ%3D%3D',
    },
  },
  problem: {
    title:
      'In Algo Trading, the majority of the time goes into tech and data management, leaving less for winning strategies.',
    answer:
      'At AlgoBulls, we understand this pain intimately. It’s time to shift the paradigm, where technology works for you, not against you. Let’s elevate your trading experience together with AlgoBulls.',
    image: '/img/b2c-problem.svg',
    imageAlt: 'b2c problem image',
  },
  statistics: pythonBuildStats,

  solutions: [
    {
      title: 'Complex Strategy Creation',
      icon: '/img/b2c-root-complex.svg',
    },
    {
      title: 'Inadequate support for Strategy creation as well as Execution',
      icon: '/img/b2c-root-support.svg',
    },
    {
      title: 'Data processing challenges',
      icon: '/img/b2c-root-data.svg',
    },
    {
      title: 'Need coding or technical expertise to create strategies',
      icon: '/img/b2c-root-expert.svg',
    },
    {
      title: 'Limited coding flexibility of the platform',
      icon: '/img/b2c-root-code.svg',
    },
  ],
  features: pythonFeatureList,
};

export const modals = {
  generalQuery: {
    title: 'Contact Us',
    subtitle: "Fill out and we'll get in touch with you",
  },
  requestQuote: {
    title: 'Quote Request',
    alert:
      'Please fill out the form below to request a quote. We will get back to you within 1-2 working days of receiving your request. Thank you for your patience.',
  },
  partnerWithUs: {
    title: 'Collaborate with AlgoBulls for a Quantitative Revolution!',
    subtitle:
      'Join hands with AlgoBulls to inspire the next generation of quantitative enthusiasts. Be a part of shaping innovative competitions and future-ready talent. Share your details below to explore partnership opportunities.',
  },
  sponsorAnEvent: {
    title: 'Empower the Future of Quantitative Innovation!',
    subtitle:
      'Make your mark by sponsoring our Quant Quest competition. Connect with top-tier talent, showcase your brand, and support the next wave of quantitative leaders. Fill out the form to discuss sponsorship possibilities.',
  },
  contactUs: {
    title: 'Get in Touch with AlgoBulls',
    subtitle:
      'Have questions or need assistance regarding our Quant Quest competition? We’re here to help! Complete the form below, and our team will get back to you promptly.',
  },
};

export const blogCategory = {
  'Algo Trading': {
    title: 'Algo Trading Basics & Beyond: Your Go-To Resource with AlgoBulls',
    description:
      "Unlock Algo Trading with AlgoBulls' blog. Find valuable insights, strategies, and tips to advance your trading knowledge and stay ahead in the market",
  },
  'Industry Insights & Updates': {
    title: 'Stay Ahead in Algo Trading – Trends, Innovations & Market Insights',
    description:
      'Get expert insights on algo trading trends, market shifts, and innovations. Stay ahead with updates on emerging technologies and automation.',
  },
};
export const blogSubCategory = {
  'Basics and Fundamentals': {
    title: 'Basics & Fundamentals: Your Essential Algo Trading Guide',
    description:
      "Master the foundations of algo trading, explore how strategies are built, and learn to create your own with AlgoBulls Basics—your beginner's guide.",
  },
  'Market Analysis and Testing': {
    title:
      'Market Analysis & Testing: Comparative Insights & Backtesting Strategies',
    description:
      'Explore in-depth comparative market analysis, backtesting techniques, and data-driven strategies to refine your algo trading decisions. Stay ahead with expert insights on market trends, risk assessment, and trading model validation.',
  },
  'Regulatory & Compliance Updates': {
    title: 'SEBI & Global Regulatory Updates – Stay Compliant & Informed',
    description:
      'Stay updated on SEBI regulations, compliance changes, and risk protocols in algo trading. Learn new guidelines to trade securely and efficiently.',
  },
  'Advanced Trading Techniques': {
    title: 'Advanced Trading Techniques',
    description:
      'Unlock cutting-edge advanced trading techniques with our expert insights. Master algorithmic trading, AI-driven strategies, and robust risk management to optimise performance and achieve consistent profitability in dynamic markets.',
  },
};

export const quantQuest = {
  problems: [
    {
      step: '01',
      title: 'Tailored Competitions',
      description:
        'Flexible formats allow events to be conducted with or without campus tie-ups, ensuring maximum reach and impact',
    },
    {
      step: '02',
      title: 'Proven Success',
      description:
        'Hosted across leading IITs and more with stellar participation and testimonials, Quant Quest has empowered thousands of participants to excel in algo trading.',
    },
    {
      step: '03',
      title: 'Expert-Led Workshops',
      description:
        'Engage participants with pre-event webinars and live sessions by industry experts.',
    },
    {
      step: '04',
      title: 'Real-World Skills',
      description:
        'Participants learn to create, test, and optimise trading strategies in real market conditions.',
    },
    {
      step: '05',
      title: 'Marketing Impact',
      description:
        'Leverage comprehensive campus promotions, digital campaigns, and social media buzz for unmatched exposure.',
    },
  ],
  choose: {
    heading: 'Why Choose Quant Quest?',
    options: [
      {
        icon: 'pc.svg',
        optionHeading: 'For Educational Institutions (Colleges & Universities)',
        optionPointers: [
          'Provide your students with hands-on exposure to algorithmic trading strategies.',
          'Organise engaging workshops, webinars, and competitions that align with modern trading practices.',
          'Partner with a proven platform trusted by leading IITs to enhance the credibility and impact of your events.',
          'Foster a sense of innovation, learning, and competition among your students.',
        ],
      },
      {
        icon: 'pc.svg',
        optionHeading: 'For Sponsors',
        optionPointers: [
          'Amplify your brand visibility by associating with an impactful, educational, and competitive event.',
          'Get unparalleled access to highly motivated talent pools from across the nation or the globe.',
          'Reach a diverse audience including students, traders, and professionals through strategic campus tie-ups or open competitions.',
          'Showcase your brand across workshops, social media, and event collateral while contributing to algo trading education.',
        ],
      },
      {
        icon: 'pc.svg',
        optionHeading: 'For Trading/Educational Institutions',
        optionPointers: [
          'Offer your students, followers, or course participants an interactive and competitive way to master coding and trading strategies.',
          'Empower learners with real-world algo trading insights while boosting engagement and skill development.',
          'Stand out as a leader in trading education by incorporating a global-scale competition into your curriculum.',
        ],
      },
      {
        icon: 'pc.svg',
        optionHeading: 'For Talent-Hunting Organisations',
        optionPointers: [
          'Identify the top talent in algorithmic trading through targeted competitions.',
          'Engage participants with a high prize pool, ensuring the event attracts the best minds in the algo trading space.',
          'Collaborate with AlgoBulls to tailor outreach strategies—whether through campus tie-ups or direct engagement with trading communities.',
        ],
      },
    ],
  },
  features: quantQuestFeatures,
};

export const pythonBuildData = [
  {
    feature: 'Full Python Flexibility',
    phoenixPythonBuild: 'yes',
    otherPlatforms: {
      img: 'no',
      text: 'Limited',
    },
  },
  {
    feature: 'Pre-Built Strategy Templates',
    phoenixPythonBuild: 'yes',
    otherPlatforms: 'no',
  },
  {
    feature: 'Seamless Backtesting',
    phoenixPythonBuild: 'yes',
    otherPlatforms: {
      img: 'no',
      text: 'Limited',
    },
  },
  {
    feature: 'Automated Deployment',
    phoenixPythonBuild: 'yes',
    otherPlatforms: {
      img: 'no',
      text: 'Manual Execution',
    },
  },
  {
    feature: 'Comprehensive Library Support (NumPy, Pandas, SciPy, etc.)',
    phoenixPythonBuild: 'yes',
    otherPlatforms: {
      img: 'no',
      text: 'Manual Execution',
    },
  },
  {
    feature: 'Jupyter Notebook Integration',
    phoenixPythonBuild: 'yes',
    otherPlatforms: 'no',
  },
  {
    feature: 'Command Line Interface (CLI) Execution',
    phoenixPythonBuild: 'yes',
    otherPlatforms: 'no',
  },
  {
    feature: 'Machine Learning Support (TensorFlow, Keras, PyTorch)',
    phoenixPythonBuild: 'yes',
    otherPlatforms: 'no',
  },
  // {
  //   feature: 'Library Support',
  //   phoenixPythonBuild: [
  //     '✅ Quant Libraries: QuantLib, TA-Lib, AlgoBulls developed quant utility functions',
  //     '✅ ML Libraries: TensorFlow, Keras, PyTorch',
  //     '✅ Data Science Libraries: Pandas, NumPy, SciPy, Scikit-Learn',
  //   ],
  //   otherPlatforms: '❌ No',
  // },
  {
    feature: 'Cloud-Based Infrastructure',
    phoenixPythonBuild: 'yes',
    otherPlatforms: {
      img: 'no',
      text: 'Requires Own Server',
    },
  },
];

export const testimonials = [
  {
    text: "I've been trading with various platforms for a while, but AlgoBulls really stands out. It's not just fast and reliable—it feels like it was made just for us traders. The user interface is so easy to understand and use, which is a huge relief because trading can get pretty complicated. AlgoBulls is like a one-stop shop for us Python-based algo traders here in India. The backtesting engine is solid, letting me test my strategies thoroughly before I go live. Plus, their SDK fits right into my workflow, making everything smoother. If you're looking for a trading platform that makes things simpler and keeps up with your needs, AlgoBulls is definitely worth a try. It's made my trading journey smoother and more productive.",
    name: 'Kiran Thomas',
    title: 'Phoenix Python Build',
    image: '/img/placeholder-person.png',
  },
];

export const quantQuestTestimonials = [
  {
    text: 'Participating in Quant Quest, an algorithmic trading competition organized by AlgoBulls, was an incredible learning experience. I had the opportunity to test my skills and strategies on a real-time trading platform. The competition was challenging yet fun and rewarding. The speaker sessions were particularly insightful, as experts and mentors shared valuable tips on improving performance and optimising algorithms. I sincerely thank AlgoBulls for hosting this amazing event and providing me with the opportunity to grow as a trader.',
    name: 'Arnav Dhamankar',
    title: 'IIT Bombay Student',
    image: '/img/placeholder-person.png',
  },
  {
    text: 'Our team recently participated in the Quant Quest competition on the AlgoBulls platform and secured third place. It was a challenging but enriching experience that tested our skills through data crunching, strategy development, and competing against other teams. AlgoBulls provided excellent tools and resources, which helped us navigate the complexities of algorithmic trading. We also gained valuable insights from interacting with other participants and made some meaningful connections in the finance world. Overall, it was a rewarding experience, and we are grateful to AlgoBulls for organising this competition and allowing us to share our journey.',
    name: 'Komal Sai Ranga',
    title: 'IIT Bombay Student',
    image: '/img/testimonials/komal-sai-ranga.jpg',
  },
];
